<template>
    <div id="user_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="userHeader">  Add Reservation</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackReservationList" >
                        <i class="fp-back"></i>Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content make-reservation-crud">
                      <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" method="posts" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="userform">
                                <input type="hidden" name="resId" v-model="resId" >
                                <input type="hidden" name="pageFlag" v-model="pageFlag">
                                <span v-if="customer_comment != ''" class="error" style="margin-left:25%;margin-bottom:2%;font-size: initial;">{{customer_comment}}</span>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <!-- <div class="col form-group mt-4 pt-1" v-if="tempResRef != ''">
                                        <label class="control-label" for="location">Reservation Ref:</label>
                                        <span class="label"> {{tempResRef}}  </span>
                                    </div> -->
                                    <div class="col form-group mt-4 pt-1" v-if="tempResQty != ''">
                                        <label class="control-label" for="location">Quantity:</label>
                                        <span class="label"> {{tempResQty}} </span>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label require">Reservation Type:</label>
                                        <v-select class="close-remove" v-model="contract_type"  id="contract_type" placeholder="Select Reservation Type" label="text" :options="contractTypeArr" ref="contract_type">
                                        </v-select>
                                        <div class="field-error">{{contractTypeerror}}</div>
                                    </div> -->
                                    <!-- <div style="clear:both" v-if="resId > 0"></div>
                                    <div style="clear:both" v-if="resId > 0"></div>
                                    <div style="clear:both" v-if="resId > 0"></div> -->
                                    <div class="col form-group custom-checkbox customPadding">
                                        <div class="form-check form-check-inline">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="is_substitute" id="is_substitute" name="is_substitute" v-on:click="isSubstiute($event)">  Is Substitute
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <template v-if="is_substitute === true">
                                        <div class="col form-group">
                                            <label class="control-label require" for="contract_asset_id">Contract Asset:</label>
                                            <v-select v-model="contract_asset_id" name="contract_asset_id"
                                                    label="text" :filterable="false" :options="activeContractsArr"
                                                    @search="onSearchContractAsset" @input="selectContractAsset($event)"
                                                    placeholder="Select Contract Asset" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search Contract Asset...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{contract_asset_error_msg}}</div>
                                        </div>
                                    </template>
                                    <div v-if="resId > 0" class="col form-group">
                                        <label class="control-label require" for="reservation_no">Reservation # :</label>
                                        <input disabled="disabled" type="text" class="form-control" v-model="reservation_no" id="reservation_no" placeholder="Reservation No." name="reservation_no" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{ reservation_no_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label :class="'control-label '+isRequired"  for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id" @input="onCustomerInput($event)"
                                                label="text" :filterable="false" :options="customerArr"
                                                @search="onSearchCustomer"
                                                placeholder="Select Customer" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="location">From Location:</label>
                                        <v-select class="close-remove" v-model="locationId" name="selectLocation" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" id="location" ref="location">
                                        </v-select>
                                        <div class="field-error">{{ location_error_msg }}</div>
                                    </div>
                                    <div v-if="showToLocation" class="col form-group">
                                        <label class="control-label require" for="location">To Location:</label>
                                        <v-select class="close-remove" v-model="toLocationId" name="selectLocation" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" id="location" ref="location">
                                        </v-select>
                                        <div class="field-error">{{ toLocation_error_msg }}</div>
                                    </div>
                                    <!-- <div v-if="!showToLocation" style="clear:both"></div>
                                    <div style="clear:both" v-if="resId == 0 || is_substitute == true"></div> -->
                                    <!-- <div style="clear:both" v-if="is_substitute != true"></div> -->
                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label require">Pickup Date:</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" @dp-change="onStartChange" autocomplete="off" id="pickup_date" name="pickup_date" v-model="PickDate" :config="fromOptionsDate"></date-picker>
                                            <label for="pickup_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{pick_date_error}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="pickupTime">Pickup Time:</label>
                                        <!-- <v-select class="close-remove" v-model="PickTime"  id="pickTime" label="text" :options="timeArr">
                                        </v-select> -->
                                        <div class="input-group">
                                            <input type="text" class="form-control" v-cleave="{time: true,timePattern: ['h','m']}" v-model="PickTime" @keyup="validateTime($event)" placeholder="HH:MM" id="PickTime" name="PickTime">
                                            <!-- <input-mask id="PickTime" :alwaysShowMask="true" name="PickTime" v-model="PickTime" :mask="timeMask"
                                                :format-chars="timeMaskOptions.formatChars"
                                                :always-show-mask="timeMaskOptions.alwaysShowMask" class="form-control">
                                            </input-mask> -->
                                            <div class="input-group-append">
                                                <v-select v-model="actual_from_ampm" class="close-remove" name="actual_from_ampm" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{pick_time_error}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Dropoff Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" autocomplete="off" @dp-change="onEndChange" id="dropoff_date" name="joining_date" v-model="DropDate" :config="toOptionsDate" aria-describedby="basic-addon2"></date-picker>
                                            <label for="dropoff_date" class="fp-calendar input-calender-icon" id="basic-addon2"></label>
                                        </div>
                                        <div class="field-error">{{drop_date_error}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="dropofTime">Dropoff Time:</label>
                                        <!-- <v-select class="close-remove" v-model="DropTime"  id="dropoffTime" label="text" :options="timeArr">
                                        </v-select> -->
                                        <div class="input-group">
                                            <input type="text" class="form-control" v-cleave="{time: true,timePattern: ['h','m']}" v-model="DropTime" @keyup="validateTime($event)" placeholder="HH:MM" id="DropTime" name="DropTime">
                                            <!-- <input-mask id="DropTime" :alwaysShowMask="true" name="DropTime" v-model="DropTime" :mask="timeMask"
                                                :format-chars="timeMaskOptions.formatChars"
                                                :always-show-mask="timeMaskOptions.alwaysShowMask" class="form-control">
                                            </input-mask> -->
                                            <div class="input-group-append">
                                                <v-select v-model="actual_to_ampm" class="close-remove" name="actualFromAmPm" label="text" :options='[{text:"AM",value:"am"},{text:"PM",value:"pm"}]'>
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="field-error">{{drop_time_error}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="contract_type_id">Contract Type:</label>
                                        <!-- <a href="javascript:void(0)" v-if="osrSelection" v-on:click="addOsrPO()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add OSR PO</a> -->
                                        <v-select v-model="contract_type_id" name="contract_type_id" placeholder="Select Contract Type."
                                                label="text"
                                                :options="contracttypeArr" @input="onContractTypeSelect($event)" :disabled="disableContractType">
                                        </v-select>
                                        <div class="field-error">{{contract_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label">Estimated Miles:</label>
                                        <input name="miles" type="text" v-model="estimatedMiles"
                                                placeholder="Estimated Miles" id="checkMiles" class="form-control" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{mileserror_msg}}</div>
                                    </div>
                                    <div class="col form-group" v-if="assetFieldFlag">
                                        <label class="control-label">Asset:</label>
                                        <v-select v-model="vehicle_id" name="vehicle_id"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchAsset"
                                            placeholder="Select Asset" class="custom-ci-auto-search">
                                            <template slot="no-options" v-if="isAssetNotFound">
                                                No Record Found...
                                            </template>
                                            <template slot="no-options" v-else>
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error" v-fp-html="vehicle_error_msg"></div>
                                        <div class="field-error">{{common_error_msg}}</div>
                                    </div>
                                     <div class="col form-group">
                                        <label class="control-label require">Asset Type:</label>
                                        <v-select class="close-remove" v-model="truckType"  id="truckType" placeholder="Select Asset Type" label="text" :options="vehicleTypeArr" ref="truckType">
                                        </v-select>
                                        <div class="field-error">{{trucktypeerror}}</div>
                                    </div>
                                </div>

                                <div class="btn-groups text-right" v-if="checkAvailabilityFlag">
                                    <button id="createUserBtnStep1" class="btn btn-primary" type="button" v-on:click.prevent="loadList('')">
                                        <i class="fp-check-availability"></i> Check Availability
                                    </button>
                                </div>
                                <hr class="light-hr"/>
                                <div class="bg-white data-table p-0 mt-3 mb-3">
                                    <custom-pagination
                                            :page-changed="onPageChange"
                                            :per-page-changed="onPerPageChange" :moduleName="'checkAvailability'">
                                    </custom-pagination>
                                    <vue-good-table v-if="checkAvailabilityFlag"
                                        ref="listAssetAvailability"
                                        mode="remote"
                                        title="Asset Availability"
                                        @on-page-change="onPageChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="columns"
                                        :rows="rows"
                                        :pagination-options="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        >
                                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                            <div :key="key">
                                                <div v-if="props.column.field == 'action'">
                                                    <template>
                                                        <router-link title="Upload Images" class="fp-edit" v-bind:to="{name: 'AssetInventoryUpdate',params:{id:props.row.id}}"></router-link>
                                                    </template>
                                                </div>
                                                <div v-else>
                                                    {{props.formattedRow[props.column.field]}}
                                                </div>
                                            </div>
                                        </template>
                                    </vue-good-table>
                                </div>

                                <!-- <div class="table-responsive-sm mt-3" v-if="editRate">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:300px">Section</th>
                                                <th scope="col" class="require" style="width:200px">Rate Type</th>
                                                <th scope="col" class="require text-right">Rate</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in otherRates" :key="index">
                                                <td>
                                                    <input type="hidden" v-model="row.id">
                                                    <v-select class="custom-ci-auto-search contract-data close-remove" v-model="row.sectionRateId" placeholder="Select Section" label="text" :options="sectionArr" @input="onChangeSection(index,row.sectionRateId)"></v-select>
                                                    <div class="field-error">{{ row.sectionRateError }}</div>
                                                </td>
                                                <td>
                                                    <v-select v-model="row.rateType"
                                                        label="text" :options="rateTypeArr" placeholder="Select Rate Type" class="close-remove"></v-select>
                                                    <div class="field-error">{{ row.rateTypeError }}</div>
                                                </td>
                                                <td>
                                                    <input v-model="row.rate" type="rate" class="form-control text-right" placeholder="Rate" id="rate" name="rate" @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click="removeRow(index,row.id);"> <i class="fp-remove"></i>
                                                            </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> -->
                                <div class="table-responsive-sm mt-3" v-if="editRate">
                                    <table aria-describedby="table" id="scope_Rate_table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require">Section</th>
                                                <th scope="col" class="require text-right">Day</th>
                                                 <th scope="col" class="require text-right">Week</th>
                                                 <th scope="col" class="require text-right">Month</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  v-for="(rate_row, index) in rateRows" :key="index">
                                                <td>
                                                    <input type="hidden" v-model="rate_row.id">
                                                    <v-select class="custom-ci-auto-search contract-data close-remove" v-model="rate_row.sectionRateId" placeholder="Select Section" label="text" :options="sectionArr" @input="selectSection(rate_row.sectionRateId,index)"></v-select>
                                                    <div class="field-error">{{ rate_row.sectionRateError }}</div>
                                                </td>
                                                <td v-if="rate_row.type == 'mile'">
                                                    <input v-model="rate_row.mile_rate" type="mile_rate" class="form-control text-right" placeholder="Rate" id="mile_rate" name="mile_rate" @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>
                                                <td v-else-if="rate_row.type == 'hour'">
                                                    <input v-model="rate_row.hour_rate" type="hour_rate" class="form-control text-right" placeholder="Rate" id="hour_rate" name="hour_rate"  @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>
                                                <td v-else>
                                                    <input v-model="rate_row.day_rate" type="day_rate" class="form-control text-right" placeholder="Rate" id="day_rate" name="day_rate"  @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>
                                                <td v-if="rate_row.type == 'mile'">
                                                    <input v-model="rate_row.mile_rate" type="mile_rate" class="form-control text-right" placeholder="Rate" id="mile_rate" name="mile_rate"  @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>
                                                <td v-else-if="rate_row.type == 'hour'">
                                                    <input v-model="rate_row.hour_rate" type="hour_rate" class="form-control text-right" placeholder="Rate" id="hour_rate" name="hour_rate"  @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>
                                                <td v-else>
                                                    <input v-model="rate_row.week_rate" type="week_rate" class="form-control text-right" placeholder="Rate" id="rate" name="rate"  @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>

                                                <td v-if="rate_row.type == 'mile'">
                                                    <input v-model="rate_row.mile_rate" type="mile_rate" class="form-control text-right" placeholder="Rate" id="mile_rate" name="mile_rate"  @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>
                                                <td v-else-if="rate_row.type == 'hour'">
                                                    <input v-model="rate_row.hour_rate" type="hour_rate" class="form-control text-right" placeholder="Rate" id="hour_rate" name="hour_rate"  @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>
                                                <td v-else>
                                                    <input v-model="rate_row.month_rate" type="rate"   class="form-control text-right" placeholder="Rate" id="month_rate" name="month_rate"  @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ rate_row.rateError }}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="rate_row.length != 1">
                                                         <a href="javascript:void(0)" v-on:click="removeRow(index,rate_row);"> <i class="fp-remove"></i>
                                                            </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups" v-if="editRate">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Rate
                                    </button>
                                </div>
                                <p>&nbsp;</p>

                                <template v-if="allowInsurance == 1 && !isTransferAgreement">
                                    <hr class="light-hr"/>
                                    <h5 class="color-blue font-bold">Insurance Details</h5>
                                    <template v-if="!insAlreadyStored && !onlyinschargesAlreadyStored">
                                        <div class="form-group">
                                            <label class="control-label">Customer Purchasing Insurance :</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="customer_insured_res1"> Yes
                                                        <input type="radio" v-model="customer_insured" :value="1" id="customer_insured_res1" name="customer_insured" v-on:click="customerInsuredSelected(1)">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="customer_insured_res2"> No
                                                        <input type="radio" v-model="customer_insured" :value="0" id="customer_insured_res2" name="customer_insured" v-on:click="customerInsuredSelected(0)">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>

                                                <div v-if="!insAlreadyStored && !onlyinschargesAlreadyStored" class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="customer_insured_res3"> In Process
                                                        <input type="radio" v-model="customer_insured" :value="null" id="customer_insured_res3" name="customer_insured" v-on:click="addinsuranceNeeded()">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="field-error">{{customer_insured_error_msg}}</div>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="form-row row-cols-md-4 row-cols-1" v-if="customer_insured == 1 && !onlyinschargesAlreadyStored && !insAlreadyStored">
                                        <div class="col form-group" v-if="customer_insured == 1">
                                            <label class="control-label require" for="policy_type">Policy Type:</label>
                                            <v-select v-model="policy_type" name="policy_type" placeholder="Select Policy Type"
                                                        label="text"
                                                        :options="policyTypesArr" class="close-remove" @input="onPolicyTypeSelect($event)">
                                            </v-select>
                                            <div class="field-error">{{ policy_type_error_msg }}</div>
                                        </div>
                                        <div class="col form-group" v-if="customer_insured == 1">
                                            <label class="control-label require">Insurance From Date</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="insurance_from" name="insurance_from" v-model="insurance_from" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                <label for="insurance_from" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                            </div>
                                            <div class="field-error">{{insurance_from_error_msg}}</div>
                                        </div>
                                        <div class="col form-group" v-if="customer_insured == 1">
                                            <label class="control-label require">Insurance To Date</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="insurance_to" name="insurance_to" v-model="insurance_to" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                <label for="insurance_to" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                            </div>
                                            <div class="field-error">{{insurance_to_error_msg}}</div>
                                        </div>
                                    </div>
                                    <template v-if="!onlyinschargesAlreadyStored">
                                        <label class="control-label" for="charges_title" v-if="insuranceChargesArr && insuranceChargesArr.length > 0 && !insAlreadyStored">Charges:</label>
                                        <div class="table-responsive-sm" v-if="insuranceChargesArr && insuranceChargesArr.length > 0 &&  !insAlreadyStored">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th style="width:300px;">Charge Name</th>
                                                        <th>Days</th>
                                                        <th>Charge</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(row, index) in insuranceChargesArr">
                                                        <tr v-if="row.physical_ins_charges != undefined" :key="'physical_ins' + index">
                                                            <td scope="col" >{{row.phy_charges_name}}</td>
                                                            <td scope="col">{{row.days}} Days</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.physical_ins_charges)}}</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.physical_ins_total)}}</td>
                                                        </tr>
                                                        <tr v-if="row.physical_admin_charges != undefined" :key="'physical_admin' + index">
                                                            <td scope="col" >{{row.phy_admincharges_name}}</td>
                                                            <td scope="col">-</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.physical_admin_charges)}}</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.physical_admin_total)}}</td>
                                                        </tr>

                                                        <tr v-if="row.liability_insurance_charges != undefined" :key="'liability_ins' + index">
                                                            <td scope="col" >{{row.lia_insurance_name}}</td>
                                                            <td scope="col">{{row.days}} Days</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.liability_insurance_charges)}}</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.liability_insurance_total)}}</td>
                                                        </tr>
                                                        <tr v-if="row.liability_admin_charges != undefined" :key="'liability_admin' + index">
                                                            <td scope="col" >{{row.lia_admincharges_name}}</td>
                                                            <td scope="col">-</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.liability_admin_charges)}}</td>
                                                            <td scope="col" class="text-right">${{amountFormat(row.liability_admin_total)}}</td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                        <label class="control-label" for="insurance_policy_title" v-if="insurancePolicyArr && insurancePolicyArr.length > 0">Insurance Policy:</label>
                                        <div class="btn-groups badge-buttons text-left mb-3" v-if="insurancePolicyArr && insurancePolicyArr.length > 0">
                                            <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                                <button type="button" id="getFixedConfig" v-on:click="policyView = 'active';actPolicy = 'active';expPolicy = ''" :class="'btn btn-secondary ' +actPolicy"> Active </button>
                                                <button type="button" id="getDistConfig" v-on:click="expiredPolicy" :class="'btn btn-secondary ' +expPolicy"> Expired </button>
                                            </div>
                                        </div>
                                        <div class="table-responsive" v-if="insurancePolicyArr && insurancePolicyArr.length > 0">
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th style="width:10px;"></th>
                                                        <th style="width:60px;">Policy Number</th>
                                                        <th>Insurance Company</th>
                                                        <th>Agent Name</th>
                                                        <th>Agent Contact</th>
                                                        <th>Status</th>
                                                        <th>Start Date</th>
                                                        <th>Expiry Date</th>
                                                        <th>Blanket Policy</th>
                                                        <th>Policy Type</th>
                                                        <th>Self Insured For</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, index) in insurancePolicyArr" :key="index" v-show="((row.status == 'Active' && policyView == 'active') || (row.status != 'Active' && policyView == 'expired')) ? true : false ">
                                                        <!-- <div v-show="((row.status == 'Active' && policyView == 'active') || row.status != 'Active' && policyView == 'expired') ? true : false "> -->
                                                            <td scope="col" style="width:10px;" v-if="row.status.toLowerCase() == 'active'"><!-- Active Policy allowed to select-->
                                                                <input type="checkbox" :id="'selectPolicy' + index" @input="clickRows($event,row,index)"/>
                                                            </td>
                                                            <td scope="col" style="width:10px;" v-else>&nbsp;&nbsp;</td>
                                                            <td scope="col" style="width:60px;">{{row.policy_number}}</td>
                                                            <td scope="col">{{row.insurance_company_name}}</td>
                                                            <td scope="col">{{row.agent_name}}</td>
                                                            <td scope="col">{{row.agent_contact}}</td>
                                                            <td scope="col">{{row.status}}</td>
                                                            <td scope="col">{{row.start_date}}</td>
                                                            <td scope="col">{{row.expiry_date}}</td>
                                                            <td scope="col" v-if="row.is_rental_blanket == 1">Yes</td>
                                                            <td scope="col" v-else>No</td>
                                                            <td scope="col">{{row.policy_type}}</td>
                                                            <td scope="col">{{row.self_insured_for}}</td>
                                                        <!-- </div> -->
                                                    </tr>
                                                    <tr>
                                                        <td colspan="11" v-show="(expiredFound == 'no' && policyView != 'active')">No Policy Available.</td>
                                                        <td colspan="11" v-show="(activeFound == 'no' && policyView != 'expired')">No Policy Available.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                    <!--Insurance Certificate -->
                                    <div class="form-row row-cols-md-2 row-cols-1" v-if="(customer_insured == 1 && showDropZone)">
                                        <div class="col form-group">
                                            <label class="control-label require" for="documents">Insurance Certificate (.jpg, .jpeg, .png and .pdf files are allowed)</label>
                                            <vue-dropzone
                                                id="insuranceCertificateRes"
                                                :options="insCertDropzoneOptions"
                                                :destroyDropzone=false
                                                ref="insuranceCertificateRes"
                                                :headers="insCertDropzoneOptions.headers"
                                                @vdropzone-files-added="manuallyAddFile"
                                                @vdropzone-complete="afterUploadComplete"
                                                @vdropzone-success="storeInsuranceCertificate"
                                                @vdropzone-removed-file="removeInsuranceCertificate"
                                                >
                                            </vue-dropzone>
                                            <div class="field-error">{{insurance_certificate_error_msg}}</div>
                                        </div>
                                    </div>
                                    <div class="form-row row-cols-md-2 row-cols-1" v-if="previewCertificates.length > 0">
                                        <div class="col form-group">
                                            <label class="control-label" for="attachments">Attachments</label>
                                            <template  v-for="(uFile,fKey) in previewCertificates">
                                                <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                    <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                    <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                    <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                    <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                        {{ uFile['display_name'] }}
                                                    </a>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey);">
                                                        <i class="fp-close"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <!-- Show Message If No Policy Found on basis of Customer Purchasing Insurance -->
                                    <div class="field-error" v-if="noInsPolicyFound">
                                        <template v-if="customer_insured == 1">
                                            <template v-if="policy_type.value != undefined">
                                                <template v-if="policy_type.value == 'physical'">
                                                    <span>No Liability Policy Found For Customer.</span>
                                                </template>
                                                <template v-else-if="policy_type.value == 'liability'">
                                                    <span>No Physical Policy Found For Customer.</span>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <span>No Insurance Policy Found For Customer.</span>
                                        </template>
                                    </div>
                                    <div class="field-error">{{insurance_error_msg}}</div>
                                </template>

                                <div class="alert alert-warning hide col-sm-6 offset-sm-2">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                                <div class="alert alert-danger hide" id="alertWarning">
                                    <strong>Vehicle  Already Reserved , Please Update The Reservation.</strong>
                                </div>
                                <span v-if="customer_id != null && ( customer_id.stage == 'potential' || customer_id.stage == 'account pending' || customer_id.stage == 'credit denied')" class="field-error">Customer's credit has not been approved.</span>
                                <div class="btn-groups">
                                    <!-- <button id="reservationBtn0" class="btn btn-primary" v-if="!checkAvailabilityFlag" type="button" v-on:click.prevent="makeTempReservation()" >
                                        <i class="fp-save-continue"></i> Continue
                                    </button>
                                    <button id="reservationBtn1" class="btn btn-primary" v-else  type="button" v-on:click.prevent="makeReservation()">
                                        <i class="fp-save-continue"></i> Continue
                                    </button> -->
                                    <button id="reservationBtn1" class="btn btn-primary" v-if="action == 'update'" type="button" v-on:click.prevent="makeReservation()">
                                        <i class="fp-save-continue"></i> Continue
                                    </button>
                                    <button id="reservationBtn1" class="btn btn-primary" v-else type="button" v-on:click.prevent="checkTriggers('')">
                                        <i class="fp-save-continue"></i> Continue
                                    </button>
                                    <router-link id="createAndContinueUserBtnStep1" class="btn btn-tertiary" v-bind:to="'/reservation/rental'">
                                        <i class="fp-close"></i> Cancel
                                    </router-link>
                                </div>

                        </form>
                        <div class="modal fade trigger-message-modal" v-show="displaySchedule" id="trigger-message-modal" ref="triggerMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="triggerMessageModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Maintenance For:</h5>
                                        <button type="button" class="close" id="btnPermitModalMessageClose" v-on:click="checkTriggers('no_action')">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <app-program-trigger :from="'rental agreement'" ref="triggerEnable"></app-program-trigger>
                                    </div>
                                    <div class="modal-footer">
                                    </div>
                                </div>
                            </div>
                        </div>
                      </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>

import Vue from "vue";
import EventBus from './event-bus';
import moment from 'moment';
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import {contractMixins} from '../mixins/contractMixins';

import ProgramTrigger from "@/components/ProgramTrigger.vue";

Vue.component("app-program-trigger", ProgramTrigger);
// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask);
import vue2Dropzone from 'vue2-dropzone';


var contex;
export default {
    name: "UserCreate",
    metaInfo() {
        return {
            title: (this.resId > 0 )? "Update Reservation | " +process.env.COPYRIGHT_NAME : "Create Reservation | " +process.env.COPYRIGHT_NAME
        }
    },
    components: {

        vueDropzone: vue2Dropzone,
    },
    mixins:[commonMixins,contractMixins,dataTableMixins],
    data: () => ({
        selectDateFormat: {value: "m/d/Y", text: '12/23/2019'},
        selectTimeFormat: {value: "h:i:s a", text: '09:58:00 am'},
        dateformat_error_msg: "",
        timeformat_error_msg: "",
        locationId:null,
        locationArr:[],
        location_error_msg:"",
        toLocationId:null,
        toLocation_error_msg:"",
        showToLocation:false,
        locationClass:"col-md-6",
        permissions: [],
        cantAccessPage: "",
        isEdit:false,
        isUpdate:false,
        options: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
            minDate:new Date,
            toolbarPlacement:'bottom',
            widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
            },
        },
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
            //minDate:new Date(),
        },
        loading:false,
        flexibleLoc:"",
        flexibleDate:"",
        trucktypeerror:"",
        // DropTime:{value: "16:00:00", text: "04:00 PM"},
        DropTime: "04:00",
        DropDate:null,
        timeerror:"",
        // PickTime:{value: "08:00:00", text: "08:00 AM"},
        PickTime: "08:00",
        PickDate:null,
        vehicleTypeArr:[],
        truckType:"",
        vehicle:"",
        truckArr:[],
        customerArr:[],
        customer_id:"",
        selectDmg:"",
        // from_us:"",
        AllcompanyArr:[{value:"",text:"Search Insurance Company"}],
        insCompanyArr:[{value:"",text:"Select Insurance Company"}],
        newInsCompany:true,
        policy:"",
        agent:"",
        agContact:"",
        agPhone:"",
        insCompany:"",
        estimatedMiles:"",
        mileserror_msg:"",
        selectLia:"",
        chargesArr:"",
        customer_error_msg:"",
        agCompany:"",
        selShow:"",
        phyCompanyName:"",
        phycompanyerrors:"",
        phyContactName:"",
        phycompanyNameerrors:"",
        phyContactNo:"",
        phynumbererrors:"",
        phyEmail:"",
        phyemailerrors:"",
        phyPolicy:"",
        uploadphyBtn:"Upload Document",
        files:[],
        phyDocerrors:"",
        searchAvailbleAsset:'search',
        reservation: true,
        loadTruck:'false',
        firstLoad:0,
        loaded:false,
        pick_date_error:'',
        drop_date_error:'',
        reservationArr:[],
        idArr:[],
        page : 1,
        perPage: 10,
        notFound:true,
        tempResRef:"",
        tempResQty:"",
        unitArr:[],
        units:"",
        paginateFlag:false,
        redirectTo: 'pending',
        vehicle_id: null,
        vehicleArr: [],
        common_error_msg : "",
        isAssetNotFound : false,
        resId: 0,
        pageFlag:"",
        action:"",
        rentalType:{value:"rental",text:"Rental"},
        checkAvailabilityFlag:true,
        assetFieldFlag:true,
        warningReservation:false,
        contracttypeArr: [],
        disableContractType:false,
        contract_type_id: null,
        isRequired:'require',
        isTransferAgreement:false,
        columns: [
            {
                label: 'Unit',
                field: 'unit_no',
                fpFieldType:"number",
                filterable: true,
                hidden:false
            },
            // {
            //     label: 'Name',
            //     field: 'name',
            //     fpFieldType:"text",
            //     filterable: false,
            //     hidden:false
            // },
            // {
            //     label: 'Vin',
            //     field: 'vin',
            //     fpFieldType:"text",
            //     filterable: true,
            //     hidden:false
            // },
            // {
            //     label: 'Status',
            //     field: 'status',
            //     fpFieldType:"option",
            //     filterable: true,
            //     hidden:false
            // },
            {
                label: 'Asset Type',
                field: 'asset_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false
            },
            // {
            //     label: 'Assigned Facility',
            //     field: 'location',
            //     fpFieldType:"option",
            //     filterable: true,
            //     hidden:false
            // },
            // {
            //     label: 'Purchase Date',
            //     field: 'purchase_date',
            //     fpFieldType:"date",
            //     filterable: true,
            //     hidden:false
            // },
            // {
            //     label: 'Date In Service',
            //     field: 'date_in_service',
            //     fpFieldType:"date",
            //     filterable: true,
            //     hidden:false
            // },
        ],
        rows: [],
        totalRecords: 0,
        serverParams: {
            columnFilters: {},
            sort: {
                field: 'id',
                type: 'desc',
            },
            page: 1,
            perPage: 10
        },
        // contractTypeArr:[{text:'Rental',value:'rental'},{text:'Lease',value:'lease'}],
        contract_type:{text:'Rental',value:'rental'},
        contractTypeerror:'',
        rental_type:'',
        otherRates:[],
        sectionArr:[],
        rateDisable:true,
        editRate:false,
        displaySchedule:false,
        rateRows:[{
            id:0,
            rateType: "",
            sectionRateId: "",
            rate:"",
            sectionRateError:"",
            rateTypeError:"",
            rateError:"",
            discount:'',
            discount_type:'',
            discount_error_msg:'',
            total:'',
            reason:'',
            reason_error_msg:'',
            section:'',
            name:'',
        }],
        pick_time_error:'',
        actual_from_ampm:{value:"am",text:"AM"},
        // actual_to_ampm:{value:"am",text:"AM"},
        actual_to_ampm:{value:"pm",text:"PM"},
        drop_time_error:'',
        reservedUnit:false,
        vehicle_error_msg:'',
        allowInsurance:0,
        customer_insured:null,
        customerInsuredLabel:"",
        customer_insured_error_msg:"",
        policy_type:"",
        policy_type_error_msg:"",
        insurancePolicyArr:[],
        insuranceChargesArr:[],
        insPolicyArr:[],
        insuranceNeeded:true,
        insAlreadyStored:false,
        onlyinschargesAlreadyStored:false,
        insurance_from:"",
        insurance_from_error_msg:"",
        insurance_to:"",
        insurance_to_error_msg:"",
        showDropZone:false,
        insCertDropzoneOptions: {
            url: process.env.ROOT_API +"/store-reservation-insurance",
            method: 'POST',
            maxFilesize: 5.00, //MB
            maxFiles: 2,
            thumbnailWidth: 150, // px
            thumbnailHeight: 150,
            addRemoveLinks: true,
            acceptedFiles: ".jpg, .jpeg, .png, .pdf",
            headers: {
                'Accept': 'application/json',
                "Authorization": "Bearer "+localStorage.getItem("tkn"),
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                "Cache-Control": "no-cache"
            },
            dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
            destroyDropzone:false,
            dictDefaultMessage: "Drop files here to upload. Files upto maximum 5 MB size are allowed.",
        },
        insCertificateFiles:[],
        validateCertificates:[],
        previewCertificates:[],
        insurance_certificate_error_msg:"",
        policyView:'active',
        expPolicy:'',
        actPolicy:'active',
        expiredFound:'no',
        activeFound:'no',
        optionsDateInsuranceFrom:{
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        optionsDateInsuranceTo:{
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        url_type:"",
        insurance_error_msg:"",
        fromVehicle:false,
        noInsPolicyFound:false,
        policyTypeLabel:"",
        policyLoad:false,
        pickDateFrom:false,
        dropDateFrom:false,
        insuranceFrom:false,
        insuranceTo:false,
        is_substitute:false,
        contract_asset_id:'',
        activeContractsArr:[],
        contract_asset_error_msg:'',
        reservation_no:"",
        reservation_no_error_msg:"",
        reservation_duplicate:false,
        credit_override:'',
        allowCreate:'false',
        customer_comment:'',
        contract_type_error_msg: "",
        requestInProgress:false,
  }),
  watch: {

        disableContractType: function(disableContractType) {
          this.isDisableVehicle = disableContractType
        },
      rentalType: function (type) {

          if ( type.value == 'transfer' ) {
              this.customer_id = {text:"000-00000000-000 | VTRL",value:0, stage:'existing'};
              this.showToLocation = true;
              this.locationClass = "col-md-3";
          } else {
              this.showToLocation = false;
              this.locationClass = "col-md-6";
              if ( this.customer_id.value == 0 ) {
                  this.customer_id = "";
              }
          }
      },
      //check permission change
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_reservation' ) {
                        self.cantAccessPage = true;

                  }
              }
          }
          self.loadRentalSearchData();
      },

        //if state value update after then change the city value also update that in thie module.
        truckType: function(type,oldType) {

            var self = this;
            if(type != null && oldType != null){
                if(type.value != oldType.value){
                    // self.rows = [];
                    self.units = "";
                    $("#createUserBtnStep1").prop('disabled',false);
                }
            }
        },
        locationId: function(type,oldType) {

            var self = this;
            if(type != null){
                if(oldType != null && type.value != oldType.value){
                    self.rows = [];
                    self.units = "";
                    $("#createUserBtnStep1").prop('disabled',false);
                }
            }
        },
        PickDate: function(type,oldType) {

            var self = this;
           if(type != oldType){
               self.rows = [];
               self.units = "";
                $("#createUserBtnStep1").prop('disabled',false);
           }
           if (self.resId != undefined && self.resId != null && self.resId > 0 && !self.pickDateFrom) {
                return;
            }else{
                if (self.customer_insured == 1){
                    if (self.PickDate != null && self.PickDate != "") {
                        self.insurance_from = self.PickDate;
                    }
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }else if (self.customer_insured == 0){
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }

        },
        DropDate: function(type,oldType) {

            var self = this;
            if( type != oldType ) {
                self.rows = [];
                self.units = "";
                $("#createUserBtnStep1").prop('disabled',false);
            }
            if (self.resId != undefined && self.resId != null && self.resId > 0 && !self.dropDateFrom) {
                return;
            }else{
                if (self.customer_insured == 1){
                    if (self.DropDate != null && self.DropDate != "") {
                        self.insurance_to = self.DropDate;
                    }
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }else if (self.customer_insured == 0){
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }

        },
        PickTime: function(type,oldType) {

            var self = this;
            if( type != oldType ) {
                // self.rows = [];
                self.units = "";
                $("#createUserBtnStep1").prop('disabled',false);
            }

        },
        DropTime: function(type,oldType) {

            var self = this;
            if( type != oldType ) {
                // self.rows = [];
                self.units = "";
                $("#createUserBtnStep1").prop('disabled',false);
            }

        },

        vehicle_id: function(type,oldType) {

            var self = this;
            self.idArr = [];
            if(type != null){
                $("#createUserBtnStep1").addClass("hide");
                $("#assetTable").addClass("hide");
                self.idArr.push({id:type.value});         // push selected vehicle id
                self.checkInsuranceRequire(1);
                if(oldType != null && type.value != oldType.value){
                    self.rows = [];
                    self.units = "";
                    $("#createUserBtnStep1").removeClass("hide");
                    $("#assetTable").removeClass("hide");
                    $("#createUserBtnStep1").prop('disabled',false);
                    self.checkInsuranceRequire(0);
                }
            }else{
                self.idArr = [];
                $("#createUserBtnStep1").removeClass("hide");
                $("#assetTable").removeClass("hide");
                self.vehicle_error_msg = '';
                self.reservedUnit = false;
                self.checkInsuranceRequire(0);
            }
            self.isAssetNotFound = false;
            if (self.vehicle_id != null && self.vehicle_id.value){
                if (self.vehicle_id != null && self.vehicle_id.vehicle_type_id){
                    self.truckType = {text:self.vehicle_id.vehicle_type,value:self.vehicle_id.vehicle_type_id};
                }
                self.searchAvailableAsset(self.vehicle_id.unit_no);
                self.checkInsuranceRequire(1);
            }else{
                self.truckType = '';
            }
        },
        insurance_from: function() {
            var self = this;
            self.insurance_from_error_msg = "";
            //prevent watch call for first time in case of update
            if (self.resId != undefined && self.resId != null && self.resId > 0 && !self.insuranceFrom) {
                return;
            }else{
                if (self.customer_insured == 1) {
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }
        },
        insurance_to: function() {
            var self = this;
            self.insurance_to_error_msg = "";
            //prevent watch call for first time in case of update
            if (self.resId != undefined && self.resId != null && self.resId > 0 && !self.insuranceTo) {
                return;
            }else{
                if (self.customer_insured == 1) {
                    self.refreshInsurancePolicy(); //refresh insurance policy and charges
                }
            }
        },
  },
  computed: {
    timeMask () {
      if (!this.due_out_time || this.due_out_time === '' || this.due_out_time[0] === '2') {
        console.log('23:59')
        return '23:59'
      }
      console.log('29:59')
      return '29:59'
    },
    timeMaskOptions () {
      return { formatChars: { '2': '[0-1]', '3': '[0-9]', '5': '[0-5]', '9': '[0-9]' }, alwaysShowMask: false }
    }
  },
  created: function() {

    $("#nxtBtn").prop('disabled',true);
    $("#prevBtn").prop('disabled',true);

  },
  beforeMount: function() {
      contex = this;
  },
  mounted: function() {

        var self = this;

        setTimeout(function() {
            //$("#reservationBtn1").prop("disabled",true);
            //hide select all button for unit list
            $(".vgt-table th:first").css("visibility","hidden");
        }, 1000);

        self.loadFieldData(['vehicleType','rental_locations','section']);
        self.getPermissions();

        var path = window.location.href;

        var decodeStr = "";
        var asset_type_name="";

        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

            decodeStr = atob(this.$route.query.data)
            //var asset_type = decodeURIComponent(escape(atob(this.$route.query.asset_type)));

        }
        if ( this.$route.query.asset_type != '' && this.$route.query.asset_type != undefined ) {

            asset_type_name = atob(this.$route.query.asset_type)
            //  console.log(assetType);
        }

        var url = new URL(path+"?"+decodeStr);
        this.resId = url.searchParams.get("resId"); // reservation id
        this.pageFlag = url.searchParams.get("for"); // to identify reservation is pending or current
        this.action = url.searchParams.get("action"); //to decide to update or create reservation
        var from = url.searchParams.get("for"); // reservation id
        self.rental_type = url.searchParams.get("from"); // reservation id
        var url_type = url.searchParams.get("url_type");
        self.url_type = url_type;
        console.log(this.pageFlag);
        console.log(this.resId);
        console.log(this.action);
        if (self.action == 'update'){
            self.editRate = true;
        }else{
            self.editRate = false;
        }
        if ( this.resId > 0 ) {
            self.getReservationDetails( this.pageFlag, this.resId, this.action );
        }
        // console.log(c);

        var cust_id = (url.searchParams.get("customer_id") != null && url.searchParams.get("customer_id") != '' && url.searchParams.get("customer_id") != 'undefined')?url.searchParams.get("customer_id"):'';
        var cust_name = (url.searchParams.get("customer_name") != null && url.searchParams.get("customer_name") != '' && url.searchParams.get("customer_name") != 'undefined')?url.searchParams.get("customer_name"):'';
        var cust_number = (url.searchParams.get("customer_number") != null && url.searchParams.get("customer_number") != '' && url.searchParams.get("customer_number") != 'undefined')?url.searchParams.get("customer_number"):'';
        var loc_id = (url.searchParams.get("location_id") != null && url.searchParams.get("location_id") != '' && url.searchParams.get("location_id") != 'undefined')?url.searchParams.get("location_id"):'';
        var loc_name = (url.searchParams.get("location_name") != null && url.searchParams.get("location_name") != '' && url.searchParams.get("location_name") != 'undefined')?url.searchParams.get("location_name"):'';
        var loc_code = (url.searchParams.get("location_code") != null && url.searchParams.get("location_code") != '' && url.searchParams.get("location_code") != 'undefined')?url.searchParams.get("location_code"):'';
        var pickup_date = (url.searchParams.get("pickup_date") != null && url.searchParams.get("pickup_date") != '' && url.searchParams.get("pickup_date") != 'undefined')?url.searchParams.get("pickup_date"):'';
        var pickup_time = (url.searchParams.get("pickup_time") != null && url.searchParams.get("pickup_time") != '' && url.searchParams.get("pickup_time") != 'undefined')?url.searchParams.get("pickup_time"):'';
        var dropoff_date = (url.searchParams.get("dropoff_date") != null && url.searchParams.get("dropoff_date") != '' && url.searchParams.get("dropoff_date") != 'undefined')?url.searchParams.get("dropoff_date"):'';
        var dropoff_time = (url.searchParams.get("dropoff_time") != null && url.searchParams.get("dropoff_time") != '' && url.searchParams.get("dropoff_time") != 'undefined')?url.searchParams.get("dropoff_time"):'';
        var estimated_miles = (url.searchParams.get("estimated_miles") != null && url.searchParams.get("estimated_miles") != '' && url.searchParams.get("estimated_miles") != 'undefined')?url.searchParams.get("estimated_miles"):'';
        var asset_type_id = (url.searchParams.get("asset_type_id") != null && url.searchParams.get("asset_type_id") != '' && url.searchParams.get("asset_type_id") != 'undefined')?url.searchParams.get("asset_type_id"):'';
        // var asset_type_name = (asset_type != null && asset_type != '' && asset_type != 'undefined')?asset_type:'';
        var tempResRef = (url.searchParams.get("reference_no") != null && url.searchParams.get("reference_no") != '' && url.searchParams.get("reference_no") != 'undefined')?url.searchParams.get("reference_no"):'';
        var tempResQty = (url.searchParams.get("qty") != null && url.searchParams.get("qty") != '' && url.searchParams.get("qty") != 'undefined')?url.searchParams.get("qty"):'';

        if(from == 'from_pending_reseravtion_list') {

            self.customer_id = {value: cust_id, text: self.titleCase(cust_name + " (" + cust_number +")")};
            self.locationId = {value: loc_id, text: self.titleCase(loc_name + " (" + loc_code +")")};

            self.PickDate = pickup_date;
            self.PickTime = pickup_time;
            self.DropDate = dropoff_date;
            self.DropTime = dropoff_time;
            self.estimatedMiles = estimated_miles;
            self.tempResRef = tempResRef;
            self.tempResQty = tempResQty;
            self.truckType = {value: asset_type_id, text: self.titleCase(asset_type_name)};
        }
        if(from == 'availability') {

            self.locationId = {value: loc_id, text: self.titleCase(loc_name)};
            self.PickDate = pickup_date;
            self.DropDate = dropoff_date;
            self.truckType = {value: asset_type_id, text: self.titleCase(asset_type_name)};
            self.units = (url.searchParams.get("unit") != null && url.searchParams.get("unit") != '' && url.searchParams.get("unit") != 'undefined')?url.searchParams.get("unit"):'';
            self.redirectTo = 'availability';
            console.log("in avalibality");
            console.log(self.units);

            self.loadList('validate');
        }

        var userObj = localStorage.getItem("user_obj");
        //if user logged in then load user location
        if ( userObj != null ) {
            var userJson = JSON.parse(userObj);
            console.log(userJson);
            if(userJson && userJson.location_id != null && userJson.location_id  != ''){
                console.log("location_id :: " + userJson.location_id);
                console.log("locationName :: " + userJson.locationName);
                self.locationId = {value: userJson.location_id, text: userJson.locationName};
            }
        }
        //pop up a new reservation no on load.
        // if (this.resId == undefined || this.resId == 0 || this.resId == ''){
        //     self.getReservationNo();
        // }
    },

  methods: {

    onCustomerInput(event) {
        var self = this;
        if (self.customer_id != null && self.customer_id != "") {
            if (self.customer_id.comment != undefined && self.customer_id.comment != ''){
                self.customer_comment = self.customer_id.comment;
            }
        }
    },

    getReservationDetails( fromList, resId, action ) {

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/get_only_reservation_data",
            type: "POST",
            data: {flag:fromList,resId:resId},
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                if(action == 'update'){

                    self.checkAvailabilityFlag = false;
                }
                if(fromList == 'pendingReservation' && action == 'update'){

                    self.assetFieldFlag = false;
                }

                var pkDate = data.content.pickUpDate.split(" ");
                var dpDate = data.content.dropOffDate.split(" ");
                self.PickDate = pkDate[0];
                self.DropDate = dpDate[0];
                self.PickTime = {value:data.content.pkTime24,text:data.content.pkTime12};
                self.DropTime = {value:data.content.dpTime24,text:data.content.dpTime12};
                self.contract_type_id = {value: data.content.conTypeId, text: self.titleCase(data.content.conType)};

                if ( data.content.pkTime12 ) {

                    //self.due_in_time = {value:data.content.due_in_time24,text:data.content.due_in_time};
                    var dueOutTime =  data.content.pkTime12.split(" ");
                    self.PickTime = dueOutTime[0];
                    self.actual_from_ampm = {value:dueOutTime[1].toLowerCase(),text:dueOutTime[1]};
                }
                if ( data.content.dpTime12 ) {

                    //self.due_in_time = {value:data.content.due_in_time24,text:data.content.due_in_time};
                    var dueInTime =  data.content.dpTime12.split(" ");
                    self.DropTime = dueInTime[0];
                    self.actual_to_ampm = {value:dueInTime[1].toLowerCase(),text:dueInTime[1]};
                }

                // set min and max date for start and end date as some time its not called...
                if ( self.DropDate != "" && self.DropDate != null ) {
                    self.$set(self.fromOptionsDate, 'maxDate', moment(self.DropDate,"MM/DD/YYYY"));
                }
                self.$set(self.toOptionsDate, 'minDate', moment(self.PickDate,"MM/DD/YYYY"));

                if ( fromList == 'pendingReservation' ) {

                    self.customer_id = {value: data.content.custId, text: self.titleCase(data.content.custCode+" | "+data.content.custName)};
                    self.locationId = {value: data.content.locId, text: self.titleCase(data.content.locCode+" | "+data.content.locName)};

                    self.estimatedMiles = data.content.miles;
                    self.tempResRef = data.content.resRefNo;
                    self.reservation_no = data.content.resRefNo;
                    self.tempResQty = data.content.resQty;
                    self.truckType = {value: data.content.vehTypeId, text: self.titleCase(data.content.vehTypeCode+" | "+data.content.vehTypeName)};

                } else {

                    self.customer_id = {value: data.content.custId, text: self.titleCase(data.content.custCode+" | "+data.content.custName)};
                    self.locationId = {value: data.content.locId, text: self.titleCase(data.content.locCode+" | "+data.content.locName)};
                    self.estimatedMiles = data.content.miles;
                    self.tempResRef = data.content.resRefNo;
                    self.reservation_no = data.content.resRefNo;
                    self.tempResQty = data.content.resQty;
                    self.truckType = {value: data.content.vehTypeId, text: self.titleCase(data.content.vehTypeCode+" | "+data.content.vehTypeName)};
                    self.vehicle_id = {value:data.content.vehicle_id,text:data.content.unit_no};
                }
                self.contract_type = {text:self.titleCase(data.content.contract_type),value:data.content.contract_type};
                if (data.content.contract_asset_id != undefined){
                    self.contract_asset_id = {text:data.content.contract_asset,value:data.content.contract_asset_id};
                }
                if (data.content.is_substitute != undefined && data.content.is_substitute == 1){
                    self.is_substitute = true;
                }else{
                    self.is_substitute = false;
                }
                // self.otherRates = data.content.other_rates;
                var rates = data.content.other_rates;
                self.rateRows = [];
                var secName = '';
                var ar = {};

                if (rates.length != undefined && rates.length > 0){
                    for (var j=0;j<rates.length;j++){
                        var rt = rates[j];
                        // var rt = rates.rate_type.value+'_id';
                        if (secName != '' && secName.toLowerCase() != rt.section.toLowerCase()){
                            self.rateRows.push(ar);
                            var ar = {};
                        }
                        var rate = rt.rateType.value+'_rate';
                        var total = rt.rateType.value+'_total';
                        var unit = rt.rateType.value+'_unit';
                        ar[rate] = rt.rate;
                        ar['sectionRateId'] = rt.sectionRateId;
                        ar['type'] = rt.type;
                        ar[unit] = rt.unit;
                        ar['section_id'] = rt.section_id;
                        ar['rateError'] = rt.rateError;
                        ar['name'] = rt.name;
                        ar['is_charge'] = rt.is_charge;
                        ar['rateTypeError'] = rt.rateTypeError;
                        ar['section'] = rt.section;
                        ar['sectionRateError'] = rt.sectionRateError;
                        ar[total] = rt.total;
                        secName = rt.section;
                    }
                    self.rateRows.push(ar);
                }
                //insurance policy for reservation
                if (data.content.customer_insured_val != undefined) {
                    self.customer_insured = data.content.customer_insured_val;
                    self.allowInsurance = 1;
                    if (data.content.customer_insured_val == 0) {
                        self.fetchInsurancePolicy("");
                        self.insPolicyArr = data.content.insurance_policy;
                        self.insurancePolicyArr = data.content.insurance_policy_details;

                    }else if (data.content.customer_insured_val == 1) {
                        self.insPolicyArr = data.content.insurance_policy;
                        self.insuranceChargesArr = data.content.insurance_charges_details;
                        // self.insurancePolicyArr = data.content.insurance_policy_details;
                        if (self.insPolicyArr.length < 1) {
                            //policy type is both
                            self.policy_type = { text: "Both",value: "both"};
                            self.policyTypeLabel = "Both";
                        }
                    }
                    //insurance charge dates on the basis of policy type
                    if (data.content.policy_type != "") {
                        if (data.content.policy_type == "physical") {
                            self.insurance_from = data.content.physical_from;
                            self.insurance_to = data.content.physical_to;
                            self.policy_type = { text: "Physical",value: "physical"};
                            self.policyTypeLabel = "Physical";
                            self.fetchInsurancePolicy("liability");
                        }
                        if(data.content.policy_type == "liability") {
                            self.insurance_from = data.content.liability_from;
                            self.insurance_to = data.content.liability_to;
                            self.policy_type = { text: "Liability",value: "liability"};
                            self.policyTypeLabel = "Liability";
                            self.fetchInsurancePolicy("physical");
                        }
                        if (data.content.policy_type == "both") {
                            self.policy_type = { text: "Both",value: "both"};
                            self.policyTypeLabel = "Both";
                            self.insurance_from = data.content.physical_from;
                            self.insurance_to = data.content.physical_to;
                            self.policyLoad = true;
                        }
                    }
                    if (self.customer_insured == 1) {
                        self.showDropZone = true;
                        if(data.content.insurance_certificates != null) {
                            self.previewCertificates = data.content.insurance_certificates;
                            self.loadFilesPreview();
                        }
                    }else{
                        self.showDropZone = false;
                    }
                    setTimeout(function(){
                        self.pickDateFrom = true;
                        self.dropDateFrom = true;
                        self.fromVehicle = true;
                        self.insuranceFrom = true;
                        self.insuranceTo = true;
                        self.loadInsurancePolicy();
                    },2000);
                }else{
                    if (self.vehicle_id != null && self.vehicle_id.value) {
                        self.allowInsurance = 1;
                    }
                    if (self.vehicle_id == null || !self.vehicle_id.value) {
                        self.fromVehicle = true;
                    }
                }
            },
            error: function (jqXHR, exception) {

                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'make-rsvtn-get-detail')
            }
        });

    },
    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {
            loading(true);
            self.searchField(loading, search, 'customer', 'rental_reservation');
        }
    },
    selectContractAsset:function(evt){
        var self = this;

        if (self.contract_asset_id != null && self.contract_asset_id.value){
            self.customer_id = {text:self.contract_asset_id.customer,value:self.contract_asset_id.customer_id};
        }
    },
    onSearchContractAsset(search, loading) {
        var self = this;

        if (search.length > 0) {
            loading(true);
            self.searchField(loading, search, 'active contract', '');
        }

    },
    validateInput(from) {

        var self = this;
        var reservationNoError = "";
        self.customer_error_msg = '';
        self.location_error_msg = '';
        self.pick_date_error = '';
        self.drop_date_error = '';
        self.mileserror_msg = '';
        self.trucktypeerror = '';
        self.common_error_msg = '';
        self.toLocation_error_msg = '';
        self.pick_time_error = '';
        self.drop_time_error = '';
        self.customer_insured_error_msg = '';
        self.policy_type_error_msg = '';
        self.insurance_from_error_msg = '';
        self.insurance_to_error_msg = '';
        self.insurance_certificate_error_msg = '';
        self.insurance_error_msg = '';
        self.contract_asset_error_msg = '';
        self.contract_type_error_msg = '';
        self.reservation_no_error_msg = '';

        var error = 0;
        //not allowing to check-availablity if reservation number typed in is duplicate
        // if(self.reservation_duplicate == true){
        //   error = 1;
        //   return;
        // }
            // if(self.reservation_no == null || !self.reservation_no){
            //   self.reservation_no_error_msg = 'Reservation no is required';
            //   error = 1;
            // }

            // reservationNoError = self.validateLength(self.reservation_no, 8, 12);
            // if (reservationNoError) {
            //   self.reservation_no_error_msg = reservationNoError;
            //   error = 1;
            // }

            if(self.contract_type_id == null || !self.contract_type_id.value || ( self.contract_type_id.code != "TRANSF" && self.contract_type_id.text != "Transfer Agreement")){
                if(self.customer_id == null || self.customer_id == ''){
                    self.customer_error_msg = 'Please choose a customer';
                    error = 1;
                }
            }
            if(self.contract_type_id == null || !self.contract_type_id.value || self.contract_type_id.value == ''){
                self.contract_type_error_msg = 'Please choose a contract type';
                error = 1;
            }
            // if(self.locationId == null ){
            //     self.locationId = '';
            // }
            if(self.locationId == null || !self.locationId.value){
                self.location_error_msg = 'Please select location';
                error = 1;
            }

            if ( self.PickDate == '' || self.PickDate == null ) {
                self.pick_date_error = 'Pickup date is required';
                error = 1;
            }
            if ( self.DropDate == '' || self.DropDate == null  ) {
                self.drop_date_error = 'Dropoff date is required';
                error = 1;
            }
            if (self.PickTime == null || self.PickTime == "") {
                self.pick_time_error = "Pickup Time Required.";
                error = 1;
            } else {
                if ( self.PickTime.indexOf("_") > -1 ) {
                    self.pick_time_error = "Please check Pick time format.";
                    error = 1;
                }
            }

            if (self.DropTime == null || self.DropTime == "") {
                self.drop_time_error = "Drop Time Required.";
                error = 1;
            } else {

                if ( self.DropTime.includes("_") ) {
                    self.drop_time_error = "Please check Due out time format.";
                    error = 1;
                }
            }

            if (self.estimatedMiles && !self.estimatedMiles.toString().match(/^\d+(\.\d*)?$/)) {
                self.mileserror_msg = 'Please enter numeric value';
                error = 1;
            }

            if (self.estimatedMiles && self.estimatedMiles >= 1000001) {
                self.mileserror_msg = 'Estimated miles must be less than 1000000';
                error = 1;
            }
            if(self.truckType == null ){
                self.truckType = '';
            }
            if (from == '' || (from != 'asset' && from != 'load_asset')){
                if(self.truckType == '' || !self.truckType.value){
                    self.trucktypeerror = 'Please select Asset Type';
                    error = 1;
                }
            }

            // parse DropDate and PickDate using Date.parse() function and then compare
            var dropOffDate = Date.parse(self.DropDate+" "+self.DropTime);
            var pickUpDate = Date.parse(self.PickDate+" "+self.PickTime);
            if(dropOffDate <= pickUpDate)
            {
                self.drop_date_error = 'Dropoff date should be greater than pickup date';
                error = 1;
            }
            if ( self.rentalType != null && self.rentalType.value == "transfer" ) {
                if(self.toLocationId == null ){
                    self.toLocationId = '';
                }
                if(self.toLocationId == '' || !self.toLocationId.value){
                    self.toLocation_error_msg = 'Please select location';
                    error = 1;
                }
            }

            if (self.is_substitute == true){
                if (self.contract_asset_id == null || !self.contract_asset_id.value){
                    self.contract_asset_error_msg = 'Please select contract asset';
                    error = 1;
                }
            }
            if (from == 'load_asset'){
                self.reservation_no_error_msg = '';
                self.customer_error_msg = '';
                self.location_error_msg = '';
                self.pick_date_error = '';
                self.drop_date_error = '';
                self.mileserror_msg = '';
                self.trucktypeerror = '';
                self.common_error_msg = '';
                self.toLocation_error_msg = '';
                self.pick_time_error = '';
                self.drop_time_error = '';
                self.customer_insured_error_msg = '';
                self.policy_type_error_msg = '';
                self.insurance_from_error_msg = '';
                self.insurance_to_error_msg = '';
                self.insurance_certificate_error_msg = '';
                self.insurance_error_msg = '';
                self.contract_asset_error_msg = '';
                self.contract_type_error_msg = '';
            }
            if (self.editRate === true){
                // for ( var i = 0; i < self.otherRates.length; i++ ) {
                //     // console.log(self.rows[i]);
                //     self.otherRates[i].sectionRateError = "";
                //     self.otherRates[i].rateTypeError = "";
                //     self.otherRates[i].rateError = "";

                //     var tempError = 0;

                //     if ( self.otherRates[i].rate == null || self.otherRates[i].rate == 0 || !self.otherRates[i].rate ) {
                //         self.otherRates[i].rateError = "Rate is required.";
                //         error = true;
                //         tempError = 1;
                //     }

                //     if ( self.otherRates[i].sectionRateId == null || !self.otherRates[i].sectionRateId.value ) {
                //         self.otherRates[i].sectionRateError = "Section is required.";
                //         error = true;
                //         tempError = 1;
                //     }

                //     if ( self.otherRates[i].rateType == null || !self.otherRates[i].rateType.value ) {
                //         self.otherRates[i].rateTypeError = "Rate type is required.";
                //         error = true;
                //         tempError = 1;
                //     }

                //     //for to check same rate added multiple times with same rate type
                //     for ( var j = 0; j < i; j++ ) {

                //         if ( tempError == 0 ) {
                //             if ( self.otherRates[i].sectionRateId.value == self.otherRates[j].sectionRateId.value
                //                             && self.otherRates[j].rateType.value == self.otherRates[i].rateType.value ) {
                //                 self.otherRates[i].sectionRateError = "Same section and rate type can not be added multiple times.";
                //                 error = true;
                //             }
                //         }
                //     }
                // }

                for ( var i = 0; i < self.rateRows.length; i++ ) {
                    // console.log(self.rows[i]);
                    self.rateRows[i].sectionRateError = "";
                    self.rateRows[i].rateTypeError = "";
                    self.rateRows[i].rateError = "";
                    self.rateRows[i].discount_error_msg = "";
                    self.rateRows[i].reason_error_msg = "";
                    var tempError = 0;

                    if ((self.rateRows[i].day_rate == null || !self.rateRows[i].day_rate) && (self.rateRows[i].week_rate == null || !self.rateRows[i].week_rate) && (self.rateRows[i].month_rate == null || !self.rateRows[i].month_rate) && (self.rateRows[i].mile_rate == null || !self.rateRows[i].mile_rate) && (self.rateRows[i].hour_rate == null || !self.rateRows[i].hour_rate)) {
                    // if ( self.rateRows[i].rate == null || self.rateRows[i].rate == 0 || !self.rateRows[i].rate ) {
                        self.rateRows[i].rateError = "Rate is required.";
                        error = true;
                        tempError = 1;
                    }

                    if ( self.rateRows[i].sectionRateId == null || !self.rateRows[i].sectionRateId.value ) {
                        self.rateRows[i].sectionRateError = "Section is required.";
                        error = true;
                        tempError = 1;
                    }

                    // if ( self.rateRows[i].rateType == null || !self.rateRows[i].rateType.value ) {
                    //     self.rateRows[i].rateTypeError = "Rate type is required.";
                    //     error = true;
                    //     tempError = 1;
                    // }
                    if (self.rateRows[i].discount != null && self.rateRows[i].discount > 0 && parseInt(self.rateRows[i].discount) > 100){
                        self.rateRows[i].discount_error_msg = "Must be less than 100";
                        error = true;
                        tempError = 1;
                    }
                    if (self.rateRows[i].discount != null && self.rateRows[i].discount > 0 && (self.rateRows[i].reason == null || !self.rateRows[i].reason.value )) {
                        self.rateRows[i].reason_error_msg = "Discount Reason required.";
                        error = true;
                        tempError = 1;
                    }

                    //for to check same rate added multiple times with same rate type
                    for ( var j = 0; j < i; j++ ) {

                        if ( tempError == 0 ) {
                            if ( self.rateRows[i].sectionRateId.value == self.rateRows[j].sectionRateId.value
                                            ) {
                                self.rateRows[i].sectionRateError = "Same section and rate type can not be added multiple times.";
                                error = true;
                            }
                        }
                    }

                }
            }

            self.PickTime = self.changeTime12To24Hrs(self.PickTime+" "+ self.actual_from_ampm.value);
            self.DropTime = self.changeTime12To24Hrs(self.DropTime+" "+ self.actual_to_ampm.value);

            //insurance policy validations for current reservation
            if (self.insuranceNeeded && from != 'asset'){
                if (String(self.customer_insured) == "") {
                    self.customer_insured_error_msg = "Customer Purchasing Insurance From Us require.";
                    error = true;
                }else{
                    if (self.customer_insured == 1){
                        if (self.policy_type == "" || !self.policy_type.value) {
                            self.policy_type_error_msg = "Policy Type require.";
                            error = true;
                        }else{
                            if (self.policy_type.value == "physical" || self.policy_type.value == "liability") {
                                if (self.insPolicyArr.length < 1) {
                                    self.insurance_error_msg = "Select Insurance Policy.";
                                    error = true;
                                }
                            }
                        }

                        if (!self.insurance_from || self.insurance_from == null || self.insurance_from == "") {
                            self.insurance_from_error_msg = "Insurance From Date require.";
                            error = true;
                        }

                        if (!self.insurance_to || self.insurance_to == null || self.insurance_to == "") {
                            self.insurance_to_error_msg = "Insurance To Date require.";
                            error = true;
                        }

                        if (new Date(self.insurance_from) > new Date(self.insurance_to)){
                            self.$swal('',"Insurance To Date should not be earlier than Insurance From Date",'info');
                            error = true;
                            return;
                            // error = true;
                        }
                    }else if (self.customer_insured == 0){
                        if (self.insPolicyArr.length < 1) {
                            self.insurance_error_msg = "Select Insurance Policy.";
                            error = true;
                        }

                        if (self.insPolicyArr.length > 0) {
                            //as per new change
                            var policyTypeArr = [];
                            for (var i = 0;i < self.insPolicyArr.length;i++) {
                                if (self.insPolicyArr[i] != undefined && self.insPolicyArr[i] != null) {
                                    if (self.insPolicyArr[i].policy_type != undefined && self.insPolicyArr[i].policy_type != null && self.insPolicyArr[i].policy_type != "") {
                                        policyTypeArr.push(self.insPolicyArr[i].policy_type);
                                    }
                                }
                            }

                            //check all values in array are equal or not
                            const allEqual = arr => arr.every( v => v === arr[0] );
                            var found = allEqual(policyTypeArr);
                            var errorMsg = "";
                            if (found) {
                                if (policyTypeArr[0] == "physical") {
                                    errorMsg = "You have selected Policy with Type Physical. Please select policy with type Liability.";
                                    self.insurance_error_msg = errorMsg;
                                    error = true;
                                }else if (policyTypeArr[0] == "liability") {
                                    errorMsg = "You have selected Policy with Type Liability. Please select policy with type Physical.";
                                    self.insurance_error_msg = errorMsg;
                                    error = true;
                                }
                            }
                            if ((policyTypeArr.includes("physical") && policyTypeArr.includes("liability")) || policyTypeArr.includes("both")) {

                            }else{
                                errorMsg = "Please select policy with type Physical AND Liability OR Both.";
                                self.insurance_error_msg = errorMsg;
                                error = true;
                            }

                        }
                    }
                }

                if (self.customer_insured == 1) {
                    if (self.showDropZone) {
                        if (self.insCertificateFiles.length == 0) {
                            self.insurance_certificate_error_msg = "Insurance Certificate Required.";
                            error = true;
                        }

                        if (self.insCertificateFiles.length > 0) {

                            if (self.insCertificateFiles.length > 2) {
                                self.insurance_certificate_error_msg = "Maximum 2 Files are allowed.";
                                error = true;
                                return;
                            }

                            if (self.validateCertificates.length > 0) {
                                for (var i = 0;i < self.validateCertificates.length;i++) {
                                    let fileObj = self.validateCertificates[i];

                                    if (fileObj.extension != undefined) {
                                        if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf") {

                                        }else{
                                            self.insurance_certificate_error_msg = "Only Images or PDF Files Are Allowed (.jpg / .jpeg / .png / .pdf).";
                                            error = true;
                                        }
                                    }

                                    if (fileObj.size != undefined) {
                                        if(fileObj.size > 5000000){
                                            self.insurance_certificate_error_msg = "File Size Should Not Be Greater Than 5 MB.";
                                            error = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

        return error;
    },
    onSearchAsset(search, loading) {

        var self = this;

        var validateForm = self.validateInput('asset');

        if ( search.length > 3 && validateForm != 1 ) {
            loading(true);
            // self.searchField(loading, search, 'vehicle');
            self.searchField(loading, search, 'active rental vehicle status', '');
            // self.searchAvailableAsset(search);
            // loading(false);

        }else{
            self.isAssetNotFound = false;
            // self.errorValidationFocus();
        }
    },

    loadList(step){
        var self = this;
        if(step==undefined){
            return;
        }
        var tType = null;
        if (self.truckType == undefined || !self.truckType.value){
            // return;
        }else{
            var tType = self.truckType.value;
        }

        var error = 0;
        if ( step == '' || step == 'load' ) {
            error = self.validateInput('load_asset');
        }
        //not allowing to check-availablity if reservation number typed-in is duplicate
        if(self.reservation_duplicate == true){
          error = 1;
          return;
        }

        if ( error == 0 ) {

            // console.log(self.unitArr);

            var fields = {
                units:self.units,
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                pickDate:self.PickDate,
                dropDate:self.DropDate,
                pickTime:self.PickTime,
                dropTime:self.DropTime,
                location_id:(self.locationId != null && self.locationId != "")?self.locationId.value:"",
                type_id:tType,
                res_type:self.contract_type.value
            };

            if ( step == '' ) {

                $("#createUserBtnStep1").text('Checking...');
                self.page = 1;
            }

            $.ajax({
                url: process.env.ROOT_API + "/get-units",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    $("#createUserBtnStep1").text('Check Availability');
                    $("#createUserBtnStep1").prop('disabled',true);
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                        // self.filteredFlag = false;
                    }
                },
                error: function (jqXHR, exception) {
                    $("#createUserBtnStep1").text('Check Availability');
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'make-rsvtn-get-unit')
                }
            });
        }else{
             self.errorValidationFocus();
        }

    },

    searchAvailableAsset(searchValue){

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        if (searchValue == '' || searchValue == undefined){
            return;
        }
        var fields = [];
        fields.push({name: "pickUpDate", value: self.PickDate});
        fields.push({name: "dropOffDate", value: self.DropDate});
        fields.push({name: "pickTime", value: self.PickTime});
        fields.push({name: "dropTime", value: self.DropTime});
        fields.push({name: "location", value: self.locationId.value});
        fields.push({name: "searchValue", value: searchValue});
        fields.push({name: "customer_id", value: self.cust_id});
        fields.push({name: "from", value: 'search'});
        fields.push({name: "res_id", value: self.resId});


        if ( self.truckType == null || !self.truckType.value ) {
            fields.push({name: "assetType", value: ""});
        }else{
            fields.push({name: "assetType", value: self.truckType.value});
        }
        // self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/available-asset/search",
            type: "POST",
            headers: this.ajxHeaders,
            data: fields,
            dataType : "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    console.log(data.content);
                    self.vehicleArr = data.content;
                    if(self.vehicleArr.length == 0){
                        self.isAssetNotFound = true;
                        self.reservedUnit = true;
                        self.vehicle_error_msg = 'Unit Not Found';
                    }else{
                        // self.vehicle_error_msg = '';
                        // if (!segments[3]){
                            if (data.content[0].reserved_msg != undefined && data.content[0].reserved_msg != ''){
                                self.vehicle_error_msg = data.content[0].reserved_msg;
                                self.reservedUnit = true;
                            }else{
                                self.vehicle_error_msg = '';
                                self.reservedUnit = false;
                                self.isAssetNotFound = false;

                            }
                        // }
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'make-rsvtn-search-avail-asset')
            }
        });
    },

    checkTriggers:function(flag){
        var self = this;
        var error = self.validateInput('');
        if (error == 0){
            if (flag == 'no_action'){
                $("#trigger-message-modal").modal("hide");
                return;
            }
            var data  = self.idArr;
            if (data.length < 1){
                flag = 'no_program';
            }

            if (flag != 'no_program'){
                var miles = 0;
                var date = self.pick_date;
                var vehArr = self.idArr;
                var vehId = 0;
                if (vehArr && vehArr.length){
                    vehId = vehArr[0].id;
                }
                // if (self.unitArr && self.unitArr.length > 0){
                //     for (var i=0; i<self.unitArr.length; i++) {
                //         if (self.unitArr[i].section && self.unitArr[i].section == 'DIST'){
                //             miles = self.unitArr[i].reading_out;
                //             date = self.unitArr[i].reading_out_date;
                //         }
                //     }
                // }
                self.$refs.triggerEnable.getMappedProgram(vehId,miles,date);
                return;
            }else{
                $("#trigger-message-modal").modal("hide");

                if (!self.checkAvailabilityFlag){
                    self.makeTempReservation();
                }else{
                    self.makeReservation();
                }
                // self.processAgreement('process');
            }
        }
    },
    makeReservation : function() {

        var self = this;
        if (self.rateRows.length > 0){
            for (var k = 0;k<self.rateRows.length;k++){
                var rt = self.rateRows[k];
                if (rt.day_rate != undefined){
                    self.otherRates.push({
                        is_charge: rt.is_charge,
                        name: rt.name,
                        rate: rt.day_rate,
                        rateError: "",
                        rateType: {text: "Day", value: "day"},
                        rateTypeError: "",
                        rate_type: "Daily Rate",
                        reason_error_msg: "",
                        section: "Fixed",
                        sectionRateError: "",
                        sectionRateId: rt.sectionRateId,
                        section_id: rt.section_id,
                        total: rt.day_total,
                        type: 'day',
                        unit: rt.day_unit
                    });
                } if (rt.week_rate != undefined){
                    self.otherRates.push({
                        is_charge: rt.is_charge,
                        name: rt.name,
                        rate: rt.week_rate,
                        rateError: "",
                        rateType: {text: "Week", value: "week"},
                        rateTypeError: "",
                        rate_type: "Weekly Rate",
                        reason_error_msg: "",
                        section: "Fixed",
                        sectionRateError: "",
                        sectionRateId: rt.sectionRateId,
                        section_id: rt.section_id,
                        total: rt.week_total,
                        type: 'week',
                        unit: rt.week_unit
                    });
                } if (rt.month_rate != undefined){
                    self.otherRates.push({
                        is_charge: rt.is_charge,
                        name: rt.name,
                        rate: rt.month_rate,
                        rateError: "",
                        rateType: {text: "Month", value: "month"},
                        rateTypeError: "",
                        rate_type: "Monthly Rate",
                        reason_error_msg: "",
                        section: rt.section,
                        sectionRateError: "",
                        sectionRateId: rt.sectionRateId,
                        section_id: rt.section_id,
                        total: rt.month_total,
                        type: 'month',
                        unit: rt.month_unit
                    });
                } if (rt.mile_rate != undefined){
                    self.otherRates.push({
                        is_charge: rt.is_charge,
                        name: rt.name,
                        rate: rt.mile_rate,
                        rateError: "",
                        rateType: {text: "Mile", value: "mile"},
                        rateTypeError: "",
                        rate_type: "Mileage",
                        reason_error_msg: "",
                        section: rt.section,
                        sectionRateError: "",
                        sectionRateId: rt.sectionRateId,
                        section_id: rt.section_id,
                        total: rt.mile_total,
                        type: 'mile',
                        unit: rt.mile_unit
                    });
                }if (rt.hour_rate != undefined){
                    self.otherRates.push({
                        is_charge: rt.is_charge,
                        name: rt.name,
                        rate: rt.hour_rate,
                        rateError: "",
                        rateType: {text: "Hour", value: "hour"},
                        rateTypeError: "",
                        rate_type: "Hourly",
                        reason_error_msg: "",
                        section: rt.section,
                        sectionRateError: "",
                        sectionRateId: rt.sectionRateId,
                        section_id: rt.section_id,
                        total: rt.hour_total,
                        type: 'hour',
                        unit: rt.hour_unit
                    });
                }
            }
        }
        var error = self.validateInput('');
        // var url = '/store_reservation_data';
        if ( error == 0 ) {

            if ( self.requestInProgress == true ) {
                return;
            }

            var data  = self.idArr;
            if (data.length < 1){
                //store temp reservation api if asset not selected
                self.makeTempReservation();
                return;
            }

            self.requestInProgress = true;
            // if (data && data.length == 1){
            //     self.checkTriggers('');
            // }

            if ( self.tempResQty != '' && self.tempResQty != null && self.tempResRef < data.length ) {

                self.$swal('','Total reserved asset quantity is less than the selected quantity ','info');
                return;

            } else if ( self.tempResQty != '' && self.tempResQty != null && self.tempResRef > data.length ) {

                self.$swal('','Total reserved asset quantity is greater than the selected quantity ','info');
                return;

            }

            var formData = new FormData();
            var time = new Date();
            time = time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

            var location = self.locationId.value;
            var truckType = self.truckType.value;
            var pick_date = self.PickDate;
            var drop_date = self.DropDate;
            var pickTime = self.PickTime;
            var dropTime = self.DropTime;
            // var customerId = self.customer_id.value;
            if (self.customer_id != null && self.customer_id != '' && self.customer_id.value){
                var customerId = self.customer_id.value;
            }else{
                var customerId = '';
            }
            var miles = self.estimatedMiles;
            var contract_type_id = self.contract_type_id.value;

            formData.append('location_id',location);
            formData.append('pickup_date',pick_date);
            formData.append('dropoff_date',drop_date);
            formData.append('pickup_time',pickTime);
            formData.append('dropoff_time',dropTime);
            formData.append('contract_type_id',contract_type_id);

            formData.append('contract_type',self.contract_type.value);

            formData.append("miles", miles);
            if (self.is_substitute == true){
                formData.append("is_substitute", 1);
            }else{
                formData.append("is_substitute", 0);
            }
            if (self.contract_asset_id != null && self.contract_asset_id.value){
                formData.append("contract_asset_id", self.contract_asset_id.value);
            }else{
                formData.append("contract_asset_id", null)
            }
            if (truckType != undefined){
                formData.append("truck_type_id", truckType);
            }
            formData.append("customer_id", customerId);
            formData.append("vehicles", JSON.stringify(data));


            formData.append("credit_override", self.credit_override);
            if(self.resId){
                formData.append("allow", 'true');
            }else{
                formData.append("allow", self.allowCreate);
            }

            if(self.pageFlag == 'pendingReservation'){

                formData.append("temp_res_id", self.resId);
            }else{
                if(self.resId){
                    formData.append("reservation_id", self.resId);
                }
            }

            // if(self.pageFlag == 'pendingReservation'){

            formData.append("other_rate_obj", JSON.stringify(self.otherRates));
            // }

            //check if rental type is transfer than get to location id
            if ( self.rentalType.value == "transfer" ) {
                formData.append("toLocationId",self.toLocationId.value);
            }
            formData.append("rentalType",self.rentalType.value);

            formData.append("url_type",self.url_type);
            formData.append("reservation_no",self.reservation_no);

            var idArr = []; //insurance policy id array
            for (var i = 0;i < self.insPolicyArr.length;i++) {
                idArr.push(self.insPolicyArr[i].insurance_policy_id);
            }
            formData.append("insurance_policies",JSON.stringify(idArr));
            formData.append("customer_insured",self.customer_insured);
            if (self.customer_insured == 1) {
                formData.append("insurance_charges",JSON.stringify(self.insuranceChargesArr));
                formData.append("insurance_from",self.insurance_from);
                formData.append("insurance_to", self.insurance_to);
                formData.append("charge_type",self.policy_type.value);
                if (self.showDropZone) {
                    formData.append("doc_found",1);
                    if(self.insCertificateFiles.length > 0){
                        formData.append("insurance_certificates",JSON.stringify(self.insCertificateFiles));
                    }else{
                        formData.append("insurance_certificates",null);
                    }
                }else{
                    formData.append("doc_found",0);
                }
            }else{
                formData.append("insurance_charges",null);
                formData.append("insurance_from",null);
                formData.append("insurance_to",null);
                formData.append("charge_type",null);
                formData.append("doc_found",0);
                formData.append("insurance_certificates",null);
            }
            console.log(formData);

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/store_reservation_data",
                type: "POST",
                crossDomain: true,
                processData: false,
                contentType: false,
                data: formData,
                dataType: "json",
                headers: this.ajxHeaders,
                success: function(data) {
                    self.loading=false;
                    self.requestInProgress = false;
                    if (data.code == 201){
                        if ( data.not_valid != undefined && (data.not_valid.includes("Sufficient credit not found. Please contact the AR team") || data.not_valid.includes("Customer's credit is not approved"))) {

                            self.$swal({
                                title: '',
                                html: 'Customer credit is not approved yet or insufficient credit found. Do you want to send credit override request?',
                                type: 'info',
                                showCancelButton: true,
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'No',
                                showCloseButton: false,
                                showLoaderOnConfirm: true
                            }).then((result) => {
                                if (result.value) {
                                    self.credit_override = 'send';
                                    // self.sendForApproval('credit_override');
                                    self.allowCreate = 'true';
                                    self.makeReservation();
                                } else {
                                    // console.log("no");
                                    return;
                                }
                            });
                            return;
                        }
                    }else{
                        if(self.resId){}else{
                            self.allowCreate = 'true';
                            // self.makeReservation();
                        }

                    }

                    if(data.status == 'reserved'){

                        self.warningReservation = true;
                        self.$swal('',data.message,'info');
                        // setTimeout(function(){

                        //     $('html, body').animate({
                        //         scrollTop: $("#alertWarning").offset().top
                        //     }, 500);

                        // },300);

                        // setTimeout(function(){

                        //     self.warningReservation = false;
                        // },10000);

                        return;
                    }
                    if (data.status == "success") {

                        if (self.credit_override == 'send'){
                            self.sendForApproval('credit_override',data.content.booking_id);
                        }
                        setTimeout(function(){
                            self.$router.push("/booking/view/"+data.content.booking_id);
                        }, 2000);


                    } else if (data.status == "error") {

                        console.log($(".error_style").length);
                        self.msgClass = "error";
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 5000);
                        }
                    }
                },
                error: function(jqXHR, exception) {
                    self.loading=false;
                    self.requestInProgress = false;
                    self.generateStatusCodeMessage(jqXHR,true,'make-rsvtn-store-data')
                }
            });
        }else{

            self.errorValidationFocus();
        }

    },

    sendForApproval:function(flag,id,from = 'reservation'){
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");

        var customerId = self.customer_id.value;

        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/user/send-notification",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                moduleId: id,
                status: 'sent',
                customerId:customerId,
                module:from,
                flag:'credit_override'
            },
            success: function (data) {
                self.loading = false;
                    if (data.status == "success") {
                        self.credit_override = '';
                        // self.$swal('','Credit Override sent for approval','success');
                    } else {
                        self.$swal('',data.message,'error');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
        },

    selectionChanged(param) {
        var self = this;
        self.idArr = [];
        var insNeed = 0;

        var ids = this.$refs['listAssetAvailability'].selectedRows;
        var typeArr = [];
        for (var i = 0; i < ids.length; i++) {
            if (typeArr.length > 0 && typeArr.includes(this.$refs['listAssetAvailability'].selectedRows[i].asset_type_id) == false){
                self.$swal('','Please select unit with same type','info');
                return;
            }
            self.truckType = {text:ids[i].type_code+' | '+ids[i].type_name,value:ids[i].asset_type_id};
            typeArr.push(this.$refs['listAssetAvailability'].selectedRows[i].asset_type_id);
            self.idArr.push({id:this.$refs['listAssetAvailability'].selectedRows[i].id})
        }
        if(param.selectedRows.length == 10) {
          EventBus.$emit('clear-selection', false);
        } else {
          EventBus.$emit('clear-all-flags', false);
        }
        self.vehicle_error_msg = '';
        self.reservedUnit = false;
        //only single asset selection allowed for insurance
        if (self.idArr.length > 0 && self.idArr.length < 2) {
            insNeed = 1;
        }
        if (self.vehicle_id != null && self.vehicle_id.value){
            insNeed = 1;
        }
        if (insNeed == 1) {
            self.checkInsuranceRequire(1);
        }else{
            self.checkInsuranceRequire(0);
        }
    },


        makeTempReservation : function() {
            var self = this;
            if ( self.requestInProgress == true ) {
                console.log('requestInProgress' + self.requestInProgress);
                return;
            }
            var error = self.validateInput('');
            var rType = '';
            if ( error == 0 ) {

                var url = '';
                if (self.pageFlag == 'pendingReservation') {
                    url = '/store_temp_booking_data';
                } else {

                    url = '/store_reservation_data';
                    var data  = self.idArr;

                    if(data.length < 1 && self.checkAvailabilityFlag) {
                        if(self.allowCreate == 'true'){
                            rType = 'temp';
                            url = '/store_temp_booking_data';
                        }else{
                            //allow to create reservation without asset and shows in pending
                            if (confirm('Are you sure you want to continue without Asset ?')) {
                                rType = 'temp';
                                url = '/store_temp_booking_data';
                            } else {
                                return;
                            }
                        }

                        // self.$swal('','Please select the asset you want to reserve','info');
                        // return;
                    }
                }

                var formData = new FormData();

                var location = self.locationId.value;
                var truckType = self.truckType.value;
                var pick_date = self.PickDate;
                var drop_date = self.DropDate;
                var pickTime = self.PickTime;
                var dropTime = self.DropTime;
                if (self.customer_id != null && self.customer_id != '' && self.customer_id.value){
                    var customerId = self.customer_id.value;
                }else{
                    var customerId = '';
                }
                var miles = self.estimatedMiles;
                var contract_type_id = self.contract_type_id.value;

                formData.append('location_id',location);
                formData.append('pickup_date',pick_date);
                formData.append('pickup_time',pickTime);
                formData.append('dropoff_date',drop_date);
                formData.append('dropoff_time',dropTime);
                formData.append("miles", miles);
                if (truckType != undefined){
                    formData.append("truck_type_id", truckType);
                }
                formData.append("customer_id", customerId);
                formData.append("contract_type", self.contract_type.value);
                formData.append("quantity", self.tempResQty);
                formData.append("contract_type_id", contract_type_id);

                if(data && data.length < 1) {

                    formData.append("flex_location", 0);
                    formData.append("flex_date", 0);
                }

                if(self.pageFlag == 'Reservation'){
                    formData.append("vehicles", JSON.stringify(data));
                }
                if(self.resId){

                    formData.append("reservation_id", self.resId);
                }
                //check if rental type is transfer than get to location id
                if ( self.rentalType.value == "transfer" ) {
                    formData.append("toLocationId",self.toLocationId.value);
                }
                formData.append("rentalType",self.rentalType.value);
                formData.append("other_rate_obj", JSON.stringify(self.otherRates));

                formData.append("reservation_no",self.reservation_no);

                formData.append("credit_override", self.credit_override);
                if(self.resId){
                    formData.append("allow", 'true');
                }else{
                    formData.append("allow", self.allowCreate);
                }

                self.requestInProgress = true;

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + url,
                    type: "POST",
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    data: formData,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function(data) {
                        self.loading=false;
                        // console.log(data+ 'hello');
                        //console.log(data.content[0]["id"]);
                        self.requestInProgress = false;
                        if (data.code == 201){
                        if ( data.not_valid != undefined && (data.not_valid.includes("Sufficient credit not found. Please contact the AR team") || data.not_valid.includes("Customer's credit is not approved"))) {

                            self.$swal({
                                title: '',
                                html: 'Customer credit is not approved yet or insufficient credit found. Do you want to send credit override request?',
                                type: 'info',
                                showCancelButton: true,
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'No',
                                showCloseButton: false,
                                showLoaderOnConfirm: true
                            }).then((result) => {
                                if (result.value) {
                                    self.credit_override = 'send';
                                    // self.sendForApproval('credit_override');
                                    self.allowCreate = 'true';
                                    self.makeTempReservation();
                                } else {
                                    // console.log("no");
                                    return;
                                }
                            });
                            return;
                        }
                    }else{
                        if(self.resId){}else{
                            if (self.allowCreate != 'true'){
                                self.allowCreate = 'true';
                                // self.makeTempReservation();
                            }
                        }

                    }
                        if(data.status == 'reserved'){
                            self.credit_override = '';
                            // self.sendForApproval('credit_override');
                            self.allowCreate = 'false';
                            self.warningReservation = true;
                            setTimeout(function(){

                                $('html, body').animate({
                                    scrollTop: $("#alertWarning").offset().top
                                }, 500);

                            },300);

                            setTimeout(function(){

                                self.warningReservation = false;
                            },10000);

                            // self.$swal('',data.message,'info');
                            return;
                        }
                        if (data.status == "success") {
                        // return;

                        if(self.pageFlag == 'pendingReservation' || rType == 'temp'){
                            if (self.credit_override == 'send'){
                                self.sendForApproval('credit_override',data.content.booking_id,'temp_reservation');
                            }
                            self.changeInsuranceData('temp',data.content.reservation_id);
                            self.$router.push("/pending-reservation/view/"+data.content.booking_id);
                        }else{
                            if (self.credit_override == 'send'){
                                self.sendForApproval('credit_override',data.content.booking_id);
                            }
                            self.changeInsuranceData('reservation',data.content.reservation_id);
                            self.$router.push("/booking/view/"+data.content.booking_id);
                        }

                        } else if (data.status == "error") {
                            // self.errors.push(data.content);

                            console.log($(".error_style").length);
                            self.msgClass = "error";

                            if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading=false;
                        self.requestInProgress = false;
                        self.generateStatusCodeMessage(jqXHR,true,'make-rsvtn-temp-create')
                    }
                });
            }else{
                self.errorValidationFocus();
            }
        },

        BackReservationList() {
            var self = this;
            if (self.rental_type == 'lease'){
                self.$router.push('/reservation/lease?active='+self.redirectTo);
            }else{

                this.$router.push({ name: 'RentalReservationList', query: { active: self.redirectTo }})

            }
        },

        changeInsuranceData(from,resId){

            var self =  this;

            $.ajax({
                    url: process.env.ROOT_API + "/update_reservation_insurance_data",
                    type: "POST",

                    data: {
                        flag:from,
                        resId:resId
                    },
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function(data) {
                        self.loading=false;
                        // console.log(data+ 'hello');
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {

                        } else if (data.status == "error") {
                            // self.errors.push(data.content);

                            console.log($(".error_style").length);
                            self.msgClass = "error";
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading=false;

                        self.generateStatusCodeMessage(jqXHR,true,'make-rsvtn-chnage-insurance')
                    }
                });

        },
        // addRow: function () {

        //     var self = this;
        //     var index = self.otherRates.length - 1;

        //     self.otherRates[index].sectionRateError = "";
        //     self.otherRates[index].rateTypeError = "";
        //     self.otherRates[index].rateError = "";
        //     self.otherRates[index].reason_error_msg = "";

        //     if ( self.otherRates[index].rateType != null && self.otherRates[index].rateType.value != ""
        //             && self.otherRates[index].sectionRateId != null && self.otherRates[index].sectionRateId.value != ""
        //             && self.otherRates[index].rate != "" ) {

        //         self.otherRates.push({
        //             id:0,
        //             rateType: "",
        //             sectionRateId: "",
        //             section_id:'',
        //             name:'',
        //             type:'',
        //             rate:"",
        //             sectionRateError:"",
        //             rateTypeError:"",
        //             rateError:"",
        //             section:'',
        //             discount_error_msg:'',
        //             total:'',
        //             is_charge:0,
        //         });

        //     } else {

        //         if (self.otherRates[index].rate == null || !self.otherRates[index].rate ) {
        //             self.otherRates[index].rateError = "Rate is required.";
        //         }
        //         if (self.otherRates[index].sectionRateId == null || !self.otherRates[index].sectionRateId.value ) {
        //             self.otherRates[index].sectionRateError = "Section rate is required.";
        //         }
        //         if (self.otherRates[index].rateType == null || !self.otherRates[index].rateType.value ) {
        //             self.otherRates[index].rateTypeError = "Section rate type is required.";
        //         }
        //     }


        // },
        addRow: function () {

            var self = this;
            var index = self.rateRows.length - 1;

            self.rateRows[index].sectionRateError = "";
            self.rateRows[index].rateTypeError = "";
            self.rateRows[index].rateError = "";

            if ( self.rateRows[index].sectionRateId != null && self.rateRows[index].sectionRateId.value != ""
                    && ((self.rateRows[index].day_rate != null && self.rateRows[index].day_rate) || (self.rateRows[index].week_rate != null && self.rateRows[index].week_rate) || (self.rateRows[index].month_rate != null && self.rateRows[index].month_rate) || (self.rateRows[index].mile_rate != null && self.rateRows[index].mile_rate) || (self.rateRows[index].hour_rate != null && self.rateRows[index].hour_rate)) /*self.rateRows[index].rate != ""*/
                    ) {

                self.rateRows.push({
                    day_id:0,
                    week_id:0,
                    month_id:0,
                    // rateType: "",
                    sectionRateId: "",
                    day_rate:"",
                    week_rate:"",
                    month_rate:"",
                    // hour_rate:"",
                    sectionRateError:"",
                    // rateTypeError:"",
                    rateError:"",
                    day_total:'',
                    week_total:'',
                    month_total:'',
                    day_unit:'',
                    week_unit:'',
                    month_unit:'',
                    is_charge:0,
                    section:'',
                    name:'',
                });

            } else {
                if ((self.rateRows[index].day_rate == null || !self.rateRows[index].day_rate) && (self.rateRows[index].week_rate == null || !self.rateRows[index].week_rate) && (self.rateRows[index].month_rate == null || !self.rateRows[index].month_rate) && (self.rateRows[index].mile_rate == null || !self.rateRows[index].mile_rate) && (self.rateRows[index].hour_rate == null || !self.rateRows[index].hour_rate)) {
                    self.rateRows[index].rateError = "Rate is required.";
                }
                if (self.rateRows[index].sectionRateId == null || !self.rateRows[index].sectionRateId.value ) {
                    self.rateRows[index].sectionRateError = "Section rate is required.";
                }
            }


        },
        selectSection:function(sec,ind){
            var self = this;

            if (sec.type != undefined){
                if (sec.type == 'mile'){
                    self.rateRows.splice(ind, 1);
                    self.rateRows.push({
                        mile_id:0,
                        sectionRateId: sec,
                        mile_rate:"",
                        sectionRateError:"",
                        rateError:"",
                        mile_total:'',
                        mile_unit:'',
                        is_charge:0,
                        type:'mile',
                        name:sec.code,
                        section:sec.code,
                    });

                }
                if (sec.type == 'hour'){
                    self.rateRows.splice(ind, 1);
                    self.rateRows.push({
                        hour_id:0,
                        sectionRateId: sec,
                        hour_rate:"",
                        sectionRateError:"",
                        rateError:"",
                        hour_total:'',
                        hour_unit:'',
                        is_charge:0,
                        type:'hour',
                        name:sec.code,
                        section:sec.code,
                    });
                }
            }
        },
        removeRow: function (index,rowId) {

            var self = this;
            self.rateRows.splice(index, 1);
        },
        onChangeSection:function(ind,obj){
            var self = this;

            if (obj.code){
                self.otherRates[ind].name = obj.code;
            }else{
                self.otherRates[ind].name = obj.name;
            }
        },
        checkInsuranceRequire(flag) {
            var self = this;
            console.log("checkInsuranceRequire :: 1" + flag);
            if (self.resId != undefined && self.resId != null && self.resId > 0 && !self.fromVehicle) {
                console.log("checkInsuranceRequire :: 2" + flag);
                return;
            }
            console.log("checkInsuranceRequire :: 3" + flag);
            self.allowInsurance = flag;
            // if (flag == 1) {
                console.log("checkInsuranceRequire :: 4" + flag);
                self.customer_insured_error_msg = "";
                self.policy_type = "";
                self.policy_type_error_msg = "";
                self.insurance_error_msg = "";
                self.customer_insured = null;
                self.insurancePolicyArr = [];
                self.insuranceChargesArr = [];
                self.insPolicyArr = [];
                self.insurance_from = "";
                self.insurance_to = "";
                self.insurance_from_error_msg = "";
                self.insurance_to_error_msg = "";
                self.noInsPolicyFound = false;
                self.insCertificateFiles = [];
                self.validateCertificates = [];
                self.insurance_certificate_error_msg = "";
                self.removeCertificateFiles();
            // }
        },
        customerInsuredSelected(value) {
            var self = this;
            var error = false;
            self.customer_insured_error_msg = "";
            self.policy_type = "";
            self.policy_type_error_msg = "";
            self.insurance_error_msg = "";
            self.customer_insured = value;
            self.insurancePolicyArr = [];
            self.insuranceChargesArr = [];
            self.insPolicyArr = [];
            self.insurance_from = "";
            self.insurance_to = "";
            self.insurance_from_error_msg = "";
            self.insurance_to_error_msg = "";
            self.noInsPolicyFound = false;
            self.insCertificateFiles = [];
            self.validateCertificates = [];
            self.previewCertificates = [];
            self.insurance_certificate_error_msg = "";
            if (self.customer_id == null || !self.customer_id.value) {
                self.$swal('','Please Select Customer.','info');
                error = true;
                return;
            }
            self.insuranceNeeded = true;
            if (!error) {
                if (self.customer_insured == 1) {
                    self.showDropZone = true;
                    if (self.PickDate != null && self.PickDate != "") {
                        //restrict insurance from and insurance to date selection between actual from and actual to
                        self.optionsDateInsuranceFrom.minDate = self.PickDate;
                        self.optionsDateInsuranceTo.minDate = self.PickDate;
                        self.insurance_from = self.PickDate;
                    }
                    if (self.DropDate != null && self.DropDate != "") {
                        //restrict insurance from and insurance to date selection between actual from and actual to
                        self.optionsDateInsuranceFrom.maxDate = self.DropDate;
                        self.optionsDateInsuranceTo.maxDate = self.DropDate;
                        self.insurance_to = self.DropDate;
                    }
                    self.removeCertificateFiles();
                }else{
                    self.showDropZone = false;
                    self.fetchInsurancePolicy("");
                }
            }
        },
        addinsuranceNeeded:function(flag){
            var self = this;

            self.insuranceNeeded = false;
            self.noInsPolicyFound = false;
            self.policy_type = "";
            self.insurance_from = "";
            self.insurance_to = "";
            self.policy_type_error_msg = "";
            self.insurance_error_msg = "";
            self.insurancePolicyArr = [];
            self.insuranceChargesArr = [];
            self.insPolicyArr = [];
            self.insCertificateFiles = [];
            self.validateCertificates = [];
            self.previewCertificates = [];
            self.insurance_certificate_error_msg = "";
            self.removeCertificateFiles();
        },
        onPolicyTypeSelect(event) {
            var self = this;
            self.policy_type_error_msg = "";
            self.insurance_error_msg = "";
            self.insurancePolicyArr = [];
            self.insuranceChargesArr = [];
            self.insPolicyArr = [];
            self.noInsPolicyFound = false;
            self.insCertificateFiles = [];
            self.validateCertificates = [];
            self.insurance_certificate_error_msg = "";
            self.previewCertificates = [];
            self.removeCertificateFiles();
            if (self.policy_type != "") {
                if (self.policy_type.value == "physical") {
                    //fetch liability insurance policy
                    self.fetchInsurancePolicy("liability");
                }else if (self.policy_type.value == "liability") {
                    //fetch physical insurance policy
                    self.fetchInsurancePolicy("physical");
                }else if (self.policy_type.value == "both") {
                    //fetch charges
                    self.insurancePolicyArr = [];
                    self.fetchInsurancePolicy("both");
                }
            }
        },
        removeCertificateFiles() {
            var self = this;
            if (self.$refs.insuranceCertificateRes != undefined) {
                self.$refs.insuranceCertificateRes.removeAllFiles();
            }
        },
        fetchInsurancePolicy(policyType) {
            var self = this;
            self.customer_error_msg = "";
            self.trucktypeerror = "";
            self.pick_date_error = "";
            self.drop_date_error = "";
            self.insurance_from_error_msg = "";
            self.insurance_to_error_msg = "";
            self.insurance_certificate_error_msg = "";
            self.contract_type_error_msg = "";
            var error = false;
            var reservationId = "";
            if (self.resId != undefined && self.resId != null && self.resId != "") {
                reservationId = self.resId;
            }
            if (self.customer_id == null || !self.customer_id.value) {
                self.customer_error_msg = "Customer require.";
                error = true;
            }
            if (self.contract_type_id == null || !self.contract_type_id.value) {
                self.customer_error_msg = "Contract Type require.";
                error = true;
            }
            if (self.truckType == null || !self.truckType.value) {
                self.trucktypeerror = "Asset Type require.";
                error = true;
            }
            if (policyType == "" || policyType == "physical" || policyType == "liability") {
                if (!self.PickDate || self.PickDate == null || self.PickDate == "") {
                    self.pick_date_error = "Pickup Date require.";
                    error = true;
                }

                if (!self.DropDate || self.DropDate == null || self.DropDate == "") {
                    self.drop_date_error = "Dropoff Date require.";
                    error = true;
                }
            }
            if (policyType == "both" || policyType == "physical" || policyType == "liability") {
                if (!self.insurance_from || self.insurance_from == null || self.insurance_from == "") {
                    self.insurance_from_error_msg = "Insurance From Date require.";
                    error = true;
                }

                if (!self.insurance_to || self.insurance_to == null || self.insurance_to == "") {
                    self.insurance_to_error_msg = "Insurance To Date require.";
                    error = true;
                }

                if (new Date(self.insurance_from) > new Date(self.insurance_to)){
                    alert("Insurance To Date should not be earlier than Insurance From Date");
                    error = true;
                }
                if (self.contract_type_id == null || !self.contract_type_id.value) {
                    self.contract_type_error_msg = "Contract Type require.";
                    error = true;
                }
            }
            if (!error) {
                self.loading = true;
                var vehicleIdArr = [];
                //selected vehicle id array
                for(var i = 0;i < self.idArr.length;i++) {
                    if (self.idArr[i].id != undefined && self.idArr[i].id != null && self.idArr[i].id != "") {
                        if (!vehicleIdArr.includes(self.idArr[i].id)) {
                            vehicleIdArr.push(self.idArr[i].id);
                        }
                    }
                }
                //while page load for first time
                if (self.resId != undefined && self.resId != null) {
                    if (self.resId > 0) {
                        if (!self.policyLoad){
                            if (vehicleIdArr.length < 1) {
                                if (self.vehicle_id != null && self.vehicle_id.value) {
                                    vehicleIdArr.push(self.vehicle_id.value);
                                }
                            }
                        }
                    }
                }
                var fields = {
                    customer_id:self.customer_id.value,
                    due_out_date:self.PickDate,
                    due_in_date:self.DropDate,
                    insurance_from_date:self.insurance_from,
                    insurance_to_date:self.insurance_to,
                    policy_type:policyType,
                    vehicle_id:vehicleIdArr,
                    charge_update:0,
                    id:reservationId,
                    // contract_type_id:"R1",//contract type static R1
                    truck_type_id:self.truckType.value,
                    contract_type_id:self.contract_type_id.value,
                };

                $.ajax({
                    url: process.env.ROOT_API + "/fetch-insurance-policy/reservation",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: fields,
                    crossDomain: true,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            //update reservation page load first time
                            self.insurancePolicyArr = data.content.insurance_policy;
                            self.insuranceChargesArr = data.content.insurance_charges;
                            if (self.resId != undefined && self.resId != null) {
                                if (self.resId > 0) {
                                    if (!self.policyLoad && self.customer_insured == 1) {
                                        self.policyLoad = true;
                                        self.insurancePolicyArr = data.content.insurance_policy;
                                        //as no policy available message displayed while update
                                        for (var j = 0;j < self.insurancePolicyArr.length;j++) {
                                            if (self.insurancePolicyArr[j] != undefined && self.insurancePolicyArr[j] != null) {
                                                if (self.insurancePolicyArr[j].status == 'Active'){
                                                    self.activeFound = 'yes';
                                                }
                                                if (self.insurancePolicyArr[j].status == 'Expired'){
                                                    self.expiredFound = 'yes';
                                                }
                                            }
                                        }
                                        return;
                                    }
                                }
                            }
                            if (self.insurancePolicyArr.length == 0) {
                                self.noInsPolicyFound = true;
                            }else{
                                self.noInsPolicyFound = false;
                            }
                            //as no policy availabe message displayed while update
                            for (var j = 0;j < self.insurancePolicyArr.length;j++) {
                                if (self.insurancePolicyArr[j] != undefined && self.insurancePolicyArr[j] != null) {
                                    if (self.insurancePolicyArr[j].status == 'Active'){
                                        self.activeFound = 'yes';
                                    }
                                    if (self.insurancePolicyArr[j].status == 'Expired'){
                                        self.expiredFound = 'yes';
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-find-insurance-policy')
                    }
                });
            }
        },
        removeServerFile(fileName,key) {
            var self = this;
            var reservationId = "";
            var path = window.location.pathname;
            if (self.resId != undefined && self.resId != null && self.resId != "") {
                reservationId = self.resId;
            }

            if (confirm('Are you sure that you want to remove file? ')) {

                self.removeFileFromServer(fileName,reservationId,"server");
                self.previewCertificates.splice(key,1);

                //remove file from files array
                for ( var i = 0;i<self.insCertificateFiles.length;i++ ) {
                    if ( self.insCertificateFiles[i].includes(fileName)) {
                        self.insCertificateFiles.splice(i,1);
                        self.validateCertificates.splice(i,1);
                    }
                }
            }
        },
        manuallyAddFile(file) {
            var self = this;
            if (self.insCertificateFiles.length == 2) {
                self.insurance_certificate_error_msg = "Maximum 2 files are allowed.";
                return;
            }
        },
        afterUploadComplete(file,response){
            var self = this;
        },
        storeInsuranceCertificate(file,response) {
            var self = this;
            var uploadResponse = response;
            //push doc path in files array
            var uploadFile = 1;

            if (self.insCertificateFiles.length == 2) {
                self.insurance_certificate_error_msg = "Maximum 2 files are allowed.";
                uploadFile = 0;
            }

            if (uploadFile == 1) {
                self.insCertificateFiles.push(uploadResponse.content);
                if (file.type != undefined) {
                    var extension = file.type.split("/");
                    self.validateCertificates.push({
                        file_name:file.name,
                        size:file.size,
                        extension:extension[1]
                    });
                }
            }
        },
        removeInsuranceCertificate(file, xhr, error) {
            var self = this;
            var resId = "";
            if (file.xhr != undefined) {
                var fileName = JSON.parse(file.xhr.response).content;

                var fileArr = fileName.split("/");

                self.removeFileFromServer(fileArr[1],resId,"temp");

                for(var i = 0;i<self.insCertificateFiles.length;i++){
                    if ( self.insCertificateFiles[i].includes(fileName)) {
                        self.insCertificateFiles.splice(i,1);
                        self.validateCertificates.splice(i,1);
                    }
                }
            }
        },
        removeFileFromServer(file, resId,flag){

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/remove-reservation-insurance",
                type: "POST",
                data: {
                    filePath : file,
                    id: resId,
                    flag:flag
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                },
                error: function (jqXHR, exception) {

                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'remove-reservation-insurance')
                }
            });

        },
        expiredPolicy:function(){
            var self = this;

            self.policyView = 'expired';
            self.expPolicy = 'active';
            self.actPolicy = '';
        },
        clickRows(evt,row,index){
            var self = this;
            self.insurance_error_msg = "";
            if(evt.target.checked == true){
                if (self.customer_insured == 1) {
                    if (row != undefined) {
                        if (row.policy_type != undefined) {
                            if (self.policy_type != "") {
                                var checkPolicyType = "";
                                if (self.policy_type.value == "physical") {
                                    checkPolicyType = "liability";
                                }else if (self.policy_type.value == "liability") {
                                    checkPolicyType = "physical";
                                }

                                if (row.policy_type.toLowerCase() == "both") {
                                    self.$swal('','You cannot select Policy with Type Both','info');
                                    evt.target.checked = false;
                                    return;
                                }else{
                                    if (self.insPolicyArr.length < 1) {
                                        self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                                    }else{
                                        var alreadySelected = self.insPolicyArr[0].policy_type; //already selected policy
                                        if (row.policy_type.toLowerCase() == checkPolicyType) {
                                            self.$swal('','You have already selected Policy with Type ' + row.policy_type,'info');
                                            evt.target.checked = false;
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }else{
                    if (row != undefined) {
                        if (row.policy_type != undefined) {
                            self.insPolicyArr.push({insurance_policy_id:row.id,policy_type:row.policy_type.toLowerCase(),start_date:row.start_date,expiry_date:row.expiry_date});
                        }
                    }
                }
            }else{
                var i = self.insPolicyArr.indexOf(row);
                const filteredItems = self.insPolicyArr.filter(function(item) {
                    return item.insurance_policy_id !== row.id
                })
                self.insPolicyArr = filteredItems;
            }
        },
        findElementIndex(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        },
        loadInsurancePolicy() {
            var self = this;
            var selectedInsPolicy = [];
            for (var i = 0;i < self.insPolicyArr.length;i++) {
                var index = self.findElementIndex(self.insurancePolicyArr,"id",self.insPolicyArr[i].insurance_policy_id);
                $("#selectPolicy" + index). prop("checked", true); //check selected insurance policy
            }
        },
        getFilePathFromUrl (value) {

            var path = "";
            var src = value.split('/');
            var file_name = src[src.length - 1];
            var orgPath = src[src.length - 2];
            path = orgPath + "/" + file_name;
            return path;

        },
        //load files in drop zone
        loadFilesPreview:function() {
            var self = this;
            if ( self.previewCertificates.length > 0 ) {

                for ( var i = 0;i<self.previewCertificates.length;i++ ) {

                    var file = { size: self.previewCertificates[i].size, name: self.previewCertificates[i].file_name, type: self.previewCertificates[i].file_type};
                    var url = self.previewCertificates[i].url;
                    //get file path from url
                    self.insCertificateFiles.push(self.getFilePathFromUrl(self.previewCertificates[i].url));
                    self.validateCertificates.push({
                        file_name:self.previewCertificates[i].file_name,
                        extension:self.previewCertificates[i].extension
                    });
                }
            }
        },
        refreshInsurancePolicy() {
            var self = this;
            self.insurance_error_msg = "";
            self.policy_type_error_msg = "";
            self.insurancePolicyArr = [];
            self.insuranceChargesArr = [];
            self.insPolicyArr = [];
            self.insurance_from_error_msg = "";
            self.insurance_to_error_msg = "";
            self.noInsPolicyFound = false;
            self.insurance_certificate_error_msg = "";
            if (String(self.customer_insured) == "") {
                self.customer_insured_error_msg = "Customer Purchasing Insurance From Us require.";
            }else{
                if (self.customer_insured == 1) {
                    if (self.policy_type != "") {
                        if (self.policy_type.value == "physical") {
                            //fetch liability insurance policy
                            self.fetchInsurancePolicy("liability");
                        }else if (self.policy_type.value == "liability") {
                            //fetch physical insurance policy
                            self.fetchInsurancePolicy("physical");
                        }else if (self.policy_type.value == "both") {
                            //fetch charges
                            self.insurancePolicyArr = [];
                            self.fetchInsurancePolicy("both");
                        }
                    }
                }else if (self.customer_insured == 0) {
                    self.fetchInsurancePolicy("");
                }
            }
        },

        isSubstiute:function(e) {
            var self = this;
            self.contract_asset_error_msg = "";
            if(e.target.checked) {
                self.is_substitute = true;
                if(self.contract_type_id.code == 'TRANSF'){
                    self.contract_type_id = null;
                }
            }else{
                self.is_substitute = false;
                self.contract_asset_id = "";
            }
        },

        onContractTypeSelect(event) {
        var self = this;
        // self.is_substitute = false;
        // self.contract_asset_id = "";
        if (self.contract_type_id != null && self.contract_type_id != "") {
            if (self.contract_type_id.code != undefined) {
                if (self.contract_type_id.code.toLowerCase() == "osr" || self.contract_type_id.code.toLowerCase() == "osrm"){
                    self.osrSelection = true;
                }else{
                    self.osrSelection = false;
                }
                if (self.contract_type_id.code.toLowerCase() == "transf" || self.contract_type_id.code.toLowerCase() == "comp") {
                    self.isTransferAgreement = true;//agreement type is TRANSF
                    self.contract_type_id.code.toLowerCase() == "transf" ? self.isRequired = '' : self.isRequired = 'require';
                }else{
                    self.isTransferAgreement = false;
                    self.isRequired = 'require';
                }
                if (self.contract_type_id.code.toLowerCase() == "comp") {
                    self.showFields = false;
                }else{
                    self.showFields = true;
                }
                if (self.contract_type_id.code.toLowerCase() == "transf") {
                  self.isTransferCheck = true;
                }else{
                  self.isTransferCheck = false;
                }
            }else{
                self.showFields = false;
                self.isTransferAgreement = false;
            }


            if ((self.resId != undefined && self.resId != '') || (self.penresId != undefined && self.penresId != '')){
                if (self.contract_type_id.code != 'R1'){
                    self.$swal('','Reservation rates will not be used if contract type is not R1','info');
                }
            }
        }else{
            self.showFields = false;
            self.isTransferAgreement = false;
        }
        if(self.isTransferCheck){
            self.is_substitute = false;
            self.contract_asset_id = "";
        }
        //agreement type is TRANSF
        if (self.isTransferAgreement) {
            self.customer_insured = null;
            self.customer_insured_error_msg = "";
            self.policy_type = "";
            self.insuranceNeeded = false;
            self.policy_type_error_msg = "";
            self.common_error_msg = "";
            self.insurancePolicyArr = [];
            self.insuranceChargesArr = [];
            self.insPolicyArr = [];
            self.insurance_from = "";
            self.insurance_to = "";
            self.insurance_from_error_msg = "";
            self.insurance_to_error_msg = "";
            self.noInsPolicyFound = false;
            self.insCertificateFiles = [];
            self.validateCertificates = [];
            self.removeCertificateFiles();
            self.physical_from = "";
            self.physical_to = "";
            self.liability_from = "";
            self.liability_to = "";
            self.physical_from_error_msg = "";
            self.physical_to_error_msg = "";
            self.liability_from_error_msg = "";
            self.liability_to_error_msg = "";
            self.policyLabelArr = [];
            self.existingPolicyArr = [];
            self.chargesLabelArr = [];
        }else{
            //if contract type changed in case of agreement create from reservation
            if (self.$route.query.resId != undefined && self.$route.query.resId != "") {
                if (self.customer_insured == 1) {
                    self.refreshInsurancePolicy();
                }
            }
        }

        },
        loadRentalSearchData(){
            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/rental/search",
            type: "GET",
                headers: this.ajxHeaders,
                data:{
                    // params:['rentalVehicleType']
                },
                crossDomain: true,
                dataType: 'json',
                success: function (data) {
                    console.log("rental agreement")
                    console.log(data)
                    if (data.status == "success") {
                        self.contracttypeArr = data.ContractType;
                    }

                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'load-rental-agreement-search')
                }
            });
        },
        getReservationNo() {
            let self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/reservation/number",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.reservation_no = data.content.reservation_no;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-reservation-number');
                }
            });

        },
    }
};
 EventBus.$on('reservation-data', function (data) {
        console.log(data);
        contex.reservationArr = data;
    });

</script>




// WEBPACK FOOTER //
// src/components/MakeReservation.vue